/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import moment from "moment-timezone";
import {
  autoCompleteType,
  companyType,
  companyStatus,
  userRoles,
  userStatus,
  placementVacancyStatus,
  placementVacancySubscriptionStatus,
  autoCompleteStatus,
  userGenderIdentity,
  userRace,
  userSocialMediaType,
  researchType,
  placementVacancyManagedBy,
  classVacancyType,
} from "../types/enumerators";
import {
  AutoComplete,
  Company,
  Notifications,
  Contract,
  Countries,
  Faq,
  PlacementVacancy,
  PlacementVacancyWithCorporateData,
  PlacementVacancySubscription,
  PlacementVacancySubscriptionStages,
  States,
  User,
  UserContract,
  Integration,
  Class,
  ClassVacancySubscription,
  PlacementVacancySubscriptionWithVacancyData,
  ClassVacancy,
  Research,
  ClassVacancyStages,
  Cities,
  UserProfile,
  UserBootcamps,
  GeneralComment,
} from "../types/interfaces";
import api from "./api";
import { store } from "../store";
import { logDetails } from "./historicFunctions";

const date = moment().tz("America/Sao_Paulo").toISOString();

const limitedString = (limit: number): string => `, {"$limit": ${limit}}`;

const onlySizeQuery = (): string => `, {"$count": "size"}`;

const paginationString = (page: number, limit?: number) => {
  const pageLimit = limit ?? store.getState().configurationsState.pageLimit;
  return `, {"$skip" : ${pageLimit * (page - 1)}}${limitedString(pageLimit)}`;
};

const sortString = (sortBy: string, asc = true) =>
  `, {"$sort": {"${sortBy}": ${asc ? 1 : -1}}}`;

/*
 * Param 1: Function without page
 * Param 2: others params
 */
export const getPages = async (funct: any, ...rest: any[]) => {
  const base = await funct(...rest);
  let size = 0;
  if (base?.data?.length === 1 && base?.data[0]?.size) {
    size = base?.data[0]?.size;
  } else if (base?.length === 1 && base[0]?.size) {
    size = base[0]?.size;
  } else {
    size = base?.data?.length ?? base?.length ?? 1;
  }
  const { pageLimit } = store.getState().configurationsState;

  return Math.ceil(size / pageLimit);
};

const userRestrictions = (requestCompanyId: string): string => `, {
    "$lookup": {
      "from": "restriction",
      "localField": "bootcamps.classId",
      "foreignField": "classId",
      "as": "restriction"
    }
  }, {
    "$unwind": {
      "path": "$restriction",
      "preserveNullAndEmptyArrays": true
    }
  }, {
    "$addFields": {
      "show": {
        "$cond": [
          {
            "$or": [
              {
                "$eq": [
                  {
                    "$ifNull": [
                      "$restriction.companyIds", false
                    ]
                  }, false
                ]
              }, {
                "$in": [
                  "${requestCompanyId}", "$restriction.companyIds"
                ]
              }, {
                "$eq": [
                  {
                    "$size": "$restriction.companyIds"
                  }, 0
                ]
              }
            ]
          }, true, false
        ]
      }
    }
  }, {
    "$match": {
      "show": true
    }
  }, {
    "$project": {
      "show": 0
    }
  }`;

/* LOGIN AND ACCOUNT */

export const login = async (
  json: { user: string; password: string },
  validationJWTHeader?: any,
): Promise<any> => {
  if (!validationJWTHeader) {
    const request = await api.post("login", json);
    return request?.data;
  }

  const request = await api.post("login", json, validationJWTHeader);
  return request?.data;
};

export const loginRequestToken = async (id: string): Promise<any> => {
  try {
    const response = await api.post("/login/token", { id });
    return response.headers.authorization;
  } catch {
    return false;
  }
};

export const requestSignupLink = async (email: string): Promise<boolean> => {
  try {
    await api.post("/request_signup_link", {
      user: email,
    });
    return true;
  } catch {
    return false;
  }
};

export const requestMagicLink = async (email: string): Promise<boolean> => {
  try {
    await api.post("/request_magic_link", { user: email });
    return true;
  } catch {
    return false;
  }
};

export const getSelfUser = async (): Promise<User | null> => {
  try {
    const user = await api.get("/user");
    return user?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const resetPassword = async (password: string): Promise<boolean> => {
  try {
    await api.post("/reset_password", { password });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* NOTIFICATIONS AND FAQ */

export const getNotifications = async (
  userId: string,
  page?: number,
): Promise<Notifications | null> => {
  try {
    const response = await api.post("/get/notifications", {
      aggregate: `[{"$match": {"userId": "${userId}"}}${
        page ? paginationString(page) : ""
      }]`,
    });
    const notifications = response.data.sort(
      (
        a: { date: string | number | Date },
        b: { date: string | number | Date },
      ) => new Date(b.date).getTime() - new Date(a.date).getTime(),
    );
    return notifications ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getFAQ = async (target: string): Promise<Faq[] | null> => {
  try {
    const response = await api.post("/get/faq", {
      aggregate: `[
        {
          "$match":{
            "$or": [
              {
                "target": "${target}"
              },
              {
                "target": "*"
              }
            ]
          }
        },
        {
          "$sort": {
            "order": 1
          }
        }
      ]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const createNotifications = async (data: any): Promise<boolean> => {
  try {
    await api.post("/notifications", data);

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateNotifications = async (
  notificationId: string,
  data: any,
): Promise<boolean> => {
  try {
    await api.patch(`/notifications/${notificationId}`, data);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const deleteNotifications = async (
  notificationId: string,
): Promise<boolean> => {
  try {
    await api.delete(`/notifications/${notificationId}`);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* CONTRACTS */

export const getContractsByType = async (
  type: string,
  page?: number,
): Promise<Contract[] | null> => {
  try {
    const response = await api.post("/get/contract", {
      aggregate: `[{"$match":
            {"$and": [
              {"type": "${type}" },
              {"status": "ACTIVE"}
            ]}
          }${page ? paginationString(page) : ""}]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getContractsByUserId = async (
  userId: string,
  page?: number,
): Promise<Contract | null> => {
  try {
    const response = await api.post("/get/contract", {
      aggregate: `[{"$match": {"userId": "${userId}"}}${
        page ? paginationString(page) : ""
      }]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const createContracts = async (data: any): Promise<boolean> => {
  try {
    await api.post("/contract", data);

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateContracts = async (
  contractsId: string,
  data: any,
): Promise<boolean> => {
  try {
    await api.patch(`/contract/${contractsId}`, data);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const getUserContracts = async (
  userId: string,
  page?: number,
): Promise<UserContract | null> => {
  try {
    const response = await api.post("/get/userContract", {
      aggregate: `[{"$match": {"userId": "${userId}"}}${
        page ? paginationString(page) : ""
      }]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserContractsByContractId = async (
  userId: string,
  contractId: string,
  page?: number,
): Promise<UserContract[] | null> => {
  try {
    const response = await api.post("/get/userContract", {
      aggregate: `[{"$match":
          {"$and": [
            {"userId": "${userId}"},
            {"contractId": "${contractId}"}
          ]}
        }${page ? paginationString(page) : ""}]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const createUserContracts = async (
  data: UserContract,
): Promise<boolean> => {
  try {
    await api.post("/userContract", data);

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateUserContracts = async (
  userContractsId: string,
  data: any,
): Promise<boolean> => {
  try {
    await api.patch(`/userContract/${userContractsId}`, data);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* LOCALIZATION */

export const getCountriesList = async (
  page?: number,
): Promise<Countries[] | null> => {
  try {
    const countries = await api.post("/get/countries", {
      aggregate: `[{"$sort": {"name.pt": 1}}${
        page ? paginationString(page) : ""
      }]`,
    });
    return countries?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getStatesList = async (
  country: string,
  page?: number,
): Promise<States[] | null> => {
  try {
    const states = await api.post("/get/states", {
      aggregate: `[{"$match": {"country": "${country}"}},
      {
        "$sort": {"name.pt": 1}
      }
      ${page ? paginationString(page) : ""}]`,
    });
    return states?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getCitiesList = async (
  country: string,
  state: string,
  page?: number,
): Promise<Cities[] | null> => {
  try {
    const states = await api.post("/get/cities", {
      aggregate: `[
        {
          "$match": {
            "country": "${country}",
            "state": "${country}-${state}"
          }
        },
        {
          "$sort": {"name.pt": 1}
        } ${page ? paginationString(page) : ""}
      ]`,
    });
    return states?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

/* EMAIL */

export const sendGenericEmail = async (
  emails: string[],
  message: string,
  subject: string,
): Promise<void> => {
  try {
    await api.post("/send_generic_bulk_emails", {
      emails,
      message,
      subject,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendCandidateSignUpEmail = async (
  emails: string[],
  course: string,
): Promise<void> => {
  try {
    await api.post("/send_candidate_sign_up_bulk_emails", {
      emails,
      course,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendCandidateSignUpInterestFormEmail = async (
  emails: string[],
  course: string,
): Promise<void> => {
  try {
    await api.post("/send_candidate_sign_up_interest_form_bulk_emails", {
      emails,
      course,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendCandidateSignUpWithMediaEmail = async (
  emails: string[],
  course: string,
  d: string,
): Promise<void> => {
  try {
    await api.post("/send_candidate_sign_up_with_media_bulk_emails", {
      emails,
      course,
      date: d,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendCandidateSignUpWithOptionalMediaEmail = async (
  emails: string[],
  course: string,
): Promise<void> => {
  try {
    await api.post("/send_candidate_sign_up_with_optional_media_bulk_emails", {
      emails,
      course,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendCandidateMediaEmail = async (
  emails: string[],
  course: string,
  presentationType: string,
): Promise<void> => {
  try {
    await api.post("/send_candidate_media_bulk_emails", {
      emails,
      course,
      presentationType,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendSelectedWorkshopConfirm = async (
  email: string,
): Promise<void> => {
  try {
    await api.post("/send_selected_workshop_confirm", {
      email,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendWorkshopConfirm = async (
  classId: string,
  workshop: {
    date: string;
    url: string;
    info: string;
  },
): Promise<void> => {
  try {
    const result = await getUserEmailByWorkshop(classId);
    const emails = result?.map((item: { email: string }) => item?.email) ?? [];
    await api.post("/send_workshop_confirm", {
      emails,
      workshop,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendDiversityFormConfirm = async (
  email: string,
): Promise<void> => {
  try {
    await api.post("/send_diversity_form_confirm", {
      email,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendTechnicalTestConfirm = async (
  email: string,
): Promise<void> => {
  try {
    await api.post("/send_technical_test_confirm", {
      email,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const sendResearchConfirm = async (
  user: {
    profile: {
      name: string;
      email: string;
    };
  },
  course: string,
  type: string,
): Promise<void> => {
  try {
    await api.post("/send_employability_form_confirm", {
      user,
      course,
      type,
    });
  } catch (error) {
    console.warn(error);
  }
};

export const notifyUserInvite = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/notify_user_invite", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const subcribeUserVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/subcribe_user_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const nextStepUserVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/next_step_user_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const disapprovedUserVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/disapproved_user_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const reactivatedUserVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/reactivated_user_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const proposalUserVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/proposal_user_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const acceptedProposalUserVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/accepted_proposal_user_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const stoppedUserVacancy = async (
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/stopped_user_vacancy", {
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const finishedUserVacancy = async (
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/finished_user_vacancy", {
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const reactivateUserVacancy = async (
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/reactivate_user_vacancy", {
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updatedUserVacancy = async (
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/updated_user_vacancy", {
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const newPublicUserVacancy = async (
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/new_public_user_vacancy", {
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const newPrivateUserVacancy = async (
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/new_private_user_vacancy", {
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* TODO */
export const aprovedCompanyVacancy = async (
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/aproved_company_vacancy", {
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const acceptedProposalCompanyVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/accepted_proposal_company_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const refusedProposalCompanyVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/refused_proposal_company_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const candidateMessageCompanyVacancy = async (
  userId: string,
  vacancyId: string,
): Promise<boolean> => {
  try {
    await api.post("/candidate_message_company_vacancy", {
      userId,
      vacancyId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const notifyResearchCompany = async (
  emails: string[],
  classId: string,
): Promise<boolean> => {
  try {
    await api.post("/send_research_company_emails", {
      emails,
      classId,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const notifyResearchUser = async (
  classId: string,
  type: string,
): Promise<boolean> => {
  try {
    await api.post("/send_research_students_emails", {
      classId,
      type,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* USER */

export const getUserByIdentification = async (
  userIdentification: string,
): Promise<User | null> => {
  try {
    const user = await api.post("/get/user", {
      aggregate: `[{"$match" : {"login.identification" : "${userIdentification
        .toLowerCase()
        .trim()}"}}]`,
    });
    return user?.data[0];
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const thisUserAlreadyExists = async (
  email: string,
): Promise<{ hasEmail: boolean; hasPassword: boolean } | null> => {
  try {
    const request = await api.get(`/user_by_email/${email}`);
    return request?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserById = async (userId: string): Promise<User | null> => {
  try {
    const request = await api.get(`/user/${userId}`);
    return request?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserByToken = async (): Promise<any> => {
  try {
    const request = await api.get("/user");
    return request?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserByLegalIdentity = async (
  legalIdentity: string,
): Promise<User[] | null> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[{"$match" : {"profile.legalIdentity" : "${legalIdentity}"}}]`,
    });
    return response?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserByCompanyId = async (
  companyId: string,
): Promise<User[] | null> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[{"$match" : {"account.companyIds" : "${companyId}"}}]`,
    });
    return response?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getClassUsers = async (
  classId: string,
  page?: number,
): Promise<User[] | null> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[{"$match": {"$and": [{"account.roles": "ADMIN_CLASS_VACANCY_WORKSHOP"},{"account.classIds" : { "$in" : ["${classId}"]}}]}}${
        page ? paginationString(page) : ""
      }]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserAdminClassVacancyWorkshopOrBootcamp = async (): Promise<
  User[] | null
> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[{"$match":
        {"account.roles": {"$in" : ["ADMIN_CLASS_VACANCY_WORKSHOP", "ADMIN_CLASS_VACANCY_BOOTCAMP"]}}
      }]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserAdminClassVacancyVolunter = async (): Promise<
  User[] | null
> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[{"$match": {"account.roles": {"$in" : ["ADMIN_CLASS_VACANCY_VOLUNTEER_MEDIA"]}}}]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserAdminClassVacancyVolunterByClassVacancyId = async (
  classVacancyId: string,
): Promise<
  | {
      _id: string;
      name?: string;
      email?: string;
      classVacancy: { [x: string]: string[] };
    }[]
  | null
> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[
        {"$match":
          {"$and": [
            {"account.roles": {"$in" : ["ADMIN_CLASS_VACANCY_VOLUNTEER_MEDIA"]}},
            {"account.classVacancy.${classVacancyId}": {"$exists": true}}
          ]}
        },
        {"$project": {
          "_id": 1,
          "name": "$profile.name",
          "email": "$login.identification",
          "classVacancy": "$account.classVacancy"
        }}
      ]`,
    });

    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserAdminClassVacancyVolunterByIds = async (
  ids: string[],
): Promise<
  | {
      _id: string;
      name?: string;
      email?: string;
      classVacancy: { [x: string]: string[] };
    }[]
  | null
> => {
  let idsString = "[";
  ids?.forEach((item, index) => {
    idsString += `${index ? "," : ""}"${item}"`;
    return idsString;
  });
  idsString += "]";

  try {
    const response = await api.post("/get/user", {
      aggregate: `[
        {"$addFields": {
            "id": {"$toString": "$_id"},
        }},
        {"$match": {
          "$and": [
            {"id": {"$in": ${idsString}}},
            {"account.roles": {"$in": ["ADMIN_CLASS_VACANCY_VOLUNTEER_MEDIA"]}}
          ]
        }},
        {"$project": {
            "_id": 1,
            "name": "$profile.name",
            "email": "$login.identification",
            "classVacancy": "$account.classVacancy"
        }},
        ]`,
    });

    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getActiveUserAdmin = async (): Promise<User[] | null> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[{"$match":
        { "$and": [
          {"account.status": "ACTIVE"},
          {"account.roles": {"$in" : ["ADMIN"]}}
        ]}
      }]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const searchUsers = async (
  searchParams: string,
  limit?: number,
  companyId?: string,
  page?: number,
): Promise<User[] | null> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[{"$match":
      { "$and": [
        {"profile.name": {"$regex": "${searchParams}", "$options": "im" } },
        {"account.roles": {"$in" : ["STUDENT"]}},
        {"account.status": "ACTIVE"}
      ]}
    },
    {"$sort": {"profile.name": 1}}
    ${companyId ? userRestrictions(companyId) : ""}
    ${limit ? limitedString(limit) : ""}
    ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const patchUser = async (
  userId: string,
  data: any,
): Promise<boolean> => {
  try {
    const user = await removeCompanyToUser(data);

    if (user?.profile?.email)
      user.profile.email = user.profile.email.toLowerCase().trim();

    if (user?.login?.identification)
      user.login.identification = user.login.identification
        .toLowerCase()
        .trim();

    await api
      .patch(`/user/${userId}`, user)
      .then((res) =>
        logDetails(res.config?.url ?? "", "patchUser", "success", data),
      )
      .catch((res) => logDetails(res.config?.url ?? "", "patchUser", "error"));

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const addCompanyToUser = async (user: User | null): Promise<any> => {
  if (!user) return null;
  const parsedCompany = async (companyId: string): Promise<any> => {
    const { profile } = (await getCompany(companyId)) ?? {
      profile: { id: null, logo: null, name: null },
    };
    return {
      id: companyId,
      logo: profile?.logo,
      name: profile?.name,
    };
  };

  const listOfWorks = user?.curriculum?.works?.map((i) => i.companyId) ?? [];
  const listOfEducations =
    user?.curriculum?.educations?.map((i) => i.companyId) ?? [];
  const listOfCertificates =
    user?.curriculum?.certificates?.map((i) => i.companyId) ?? [];
  const setCompany = [
    ...listOfEducations,
    ...listOfWorks,
    ...listOfCertificates,
  ];
  const listOfFindableCompanies: any[] = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const company of setCompany) {
    if (company) {
      // eslint-disable-next-line no-await-in-loop
      const temp = await parsedCompany(company);
      listOfFindableCompanies.push(temp);
    }
  }
  const newWorks =
    user?.curriculum?.works?.map((i) => ({
      ...i,
      ...listOfFindableCompanies.find((a) => a.id === i.companyId),
    })) ?? [];
  const newEducations =
    user?.curriculum?.educations?.map((i) => ({
      ...i,
      ...listOfFindableCompanies.find((a) => a.id === i.companyId),
    })) ?? [];
  const newCertificates =
    user?.curriculum?.certificates?.map((i) => ({
      ...i,
      ...listOfFindableCompanies.find((a) => a.id === i.companyId),
    })) ?? [];
  const newUser = {
    ...user,
    curriculum: {
      ...user.curriculum,
      works: newWorks,
      certificates: newCertificates,
      educations: newEducations,
    },
  };
  return newUser;
};

export const removeCompanyToUser = async (data: any): Promise<any> => {
  if (!data) return {};

  const newData = data;
  const keysCurriculum = ["works", "educations", "certificates"];
  const keys = ["id", "logo", "name"];

  if (newData.curriculum) {
    keysCurriculum.forEach((kc) => {
      if (newData.curriculum[kc]) {
        newData.curriculum[kc].forEach(
          (itemC: { [x: string]: any }, index: string | number) => {
            keys.forEach((k) => {
              if (itemC[k]) delete newData.curriculum[kc][index][k];
            });
          },
        );
      }
    });
  }

  return newData;
};

/* COMPANY */

export const getCompanyIdReprograma = async (): Promise<string> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: `[{"$match":
                      {"profile.name": "{reprograma}"}
                  }]`,
    });

    if (response?.data && response?.data[0]) return response?.data[0]?._id;
    return "";
  } catch (error) {
    console.warn(error);
    return "";
  }
};

export const patchCompany = async (
  companyId: string,
  data: any,
): Promise<boolean> => {
  try {
    await api
      .patch(`/company/${companyId}`, data)
      .then((res) =>
        logDetails(res.config?.url ?? "", "patchCompany", "success", data),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "patchCompany", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const getCompany = async (
  companyId: string,
): Promise<Company | null> => {
  try {
    const company = await api.get(`/company/${companyId}`);
    return company?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const setNewCompany = async (
  name: string,
  type = companyType.WORK_COMPANY,
  autocomplete = companyStatus.ACTIVE,
  status = companyStatus.PENDING,
): Promise<boolean> => {
  try {
    await api.post("/company", {
      profile: {
        name,
      },
      status,
      type,
      autocomplete,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const searchCompaniesAllStatus = async (
  searchParams: string,
): Promise<Company[] | null> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: `[{"$match":
                  {"profile.name": {"$regex" : "${searchParams}", "$options": "im"}}
              }]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const searchCompaniesAutocomplete = async (
  type = companyType.WORK_COMPANY,
): Promise<Company[] | null> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: `[{"$match": {
                "$and": [
                  {"autocomplete": "ACTIVE"},
                  {"type": "${type}"},
                ]
              }}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getCompanyByName = async (
  name: string,
): Promise<Company | null> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: `[{"$match": {"profile.name": "${name}"}}]`,
    });
    return response?.data[0] ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const searchCompany = async (
  searchParams: string,
  limit?: number,
  page?: number,
): Promise<Company[] | null> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: `[{"$match": {
                "$and": [
                  {"status": "ACTIVE"},
                  {"profile.name": {"$regex" : "${searchParams}", "$options": "im"}},
                ]
              }},
              {"$sort": {"profile.name": 1}}
              ${limit ? limitedString(limit) : ""}
              ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterInvitedCompany = async (
  filters?: {
    name?: string | null;
    status?: string | null;
  },
  onlySize?: boolean,
  limit?: number,
  page?: number,
): Promise<Company[] | null> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: `[{"$match": 
                    {"$and": [
                      {"$or": [
                        {"userSuggested": false},
                        {"userSuggested": {"$exists": false}}
                      ]},
                      { "status": { "$ne": "NONE" } }
                      ${
                        filters?.name
                          ? `, {"profile.name": {"$regex" : "${filters?.name}", "$options": "im"}}`
                          : ""
                      }
                      ${
                        filters?.status
                          ? `, {"status": "${filters?.status}"}`
                          : ""
                      }
                    ]}
                  },
                  {"$addFields": {
                    "id": {"$toString": "$_id"}
                  }},
                  {"$lookup": {
                      "from": "placementVacancy",
                      "localField": "id",
                      "foreignField": "companyId",
                      "as": "placementVacancy"
                  }},
                  {"$project": {
                    "name": "$profile.name",
                    "photo": "$profile.photo",
                    "placementVacancy": {$size: "$placementVacancy"},
                    "status": "$status"
                  }}
                  ${onlySize ? onlySizeQuery() : ""}
                  ${limit ? limitedString(limit) : ""}
                  ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getAllCompanies = async (): Promise<Company[] | null> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: '[{"$match": {"status": "ACTIVE"}}]',
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getCompanyUsers = async (
  corporate: string,
  page?: number,
): Promise<User[] | null> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[
        {"$match": 
          {"$and": [
            {"account.roles": "CORPORATE"},
            {"account.companyIds" : { "$in" : ["${corporate}"]}}
          ]}
        }
        ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterCompanyUsers = async (
  corporate: string,
  filters?: {
    name?: string | null;
    email?: string | null;
    status?: string | null;
    businessUnity?: string | null;
  },
  onlySize?: boolean,
  page?: number,
): Promise<
  | {
      photo?: string;
      name?: string;
      email?: string;
      tags?: string[];
      telephone?: string;
      status?: string;
    }[]
  | null
> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[
        {"$match": 
          {"$and": [
            {"account.roles": "CORPORATE"},
            {"account.companyIds" : { "$in" : ["${corporate}"]}}
            ${
              filters?.name
                ? `, {"profile.name": {"$regex" : "${filters?.name}", "$options": "im"}}`
                : ""
            }
            ${
              filters?.email
                ? `, {"profile.email": {"$regex" : "${filters?.email}", "$options": "im"}}`
                : ""
            }
            ${
              filters?.status
                ? `, {"account.status": "${filters?.status}"}`
                : ""
            }
            ${
              filters?.businessUnity
                ? `, {"account.tags": "business_unity:${filters?.businessUnity}"}`
                : ""
            }
          ]}
        },
        {"$project": {
          "photo": "$profile.photo",
          "name": "$profile.name",
          "email": "$profile.email",
          "tags": "$account.tags",
          "telephone": "$profile.telephone",
          "status": "$account.status",
        }}
        ${onlySize ? onlySizeQuery() : ""}
        ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const sendMessageToUsers = async (
  emails: string[],
  message: string,
): Promise<void> => {
  try {
    await api.post("/send-bulk-emails", {
      emails,
      message,
    });
  } catch (error) {
    console.warn(error);
  }
};

/* VACANCY */

export const searchPlacementVacancy = async (
  searchParams: string,
  limit?: number,
  page?: number,
): Promise<PlacementVacancyWithCorporateData[] | null> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[{"$match": {
                "$and": [
                  {"$or": [
                    {"status": "ACTIVE"},
                    {"status": "PENDING"},
                  ]},
                  {"$or": [
                    {"desiredSkills": {"$in" : ["${searchParams}"]}},
                    {"description": {"$regex" : "${searchParams}", "$options": "im"}},
                    {"title": {"$regex" : "${searchParams}", "$options": "im"}}
                    ]}
                  ]
                }},
                {"$addFields": {
                    "objectCompanyId": {
                        "$convert": {
                            "input": "$companyId",
                            "to":"objectId",
                            "onError": "",
                            "onNull":""
                        }
                    }
                }},
                {"$lookup": {
                    "from": "company",
                    "localField": "objectCompanyId",
                    "foreignField": "_id",
                    "as": "companyData"
                }},
                {"$unwind": {
                  "path": "$companyData",
                }},
                {"$addFields":{
                  "companyName": "$companyData.profile.name",
                  "photo": "$companyData.profile.logo",
                  "companyWebsite": "$companyData.profile.site",
                  "companyAbout": "$companyData.profile.description",
                }},
                {"$project": {
                  "companyData": 0,
                  "objectCompanyId": 0
                }}${limit ? limitedString(limit) : ""}${
        page ? paginationString(page) : ""
      }]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getPlacementVacancy = async (
  vacancyId: string,
): Promise<PlacementVacancy | null> => {
  try {
    const vacancy = await api.get(`/placementVacancy/${vacancyId}`);
    return vacancy?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const searchCorporatePlacementVacancy = async (
  corporateId: string,
  limit?: number,
  page?: number,
): Promise<PlacementVacancy[] | null> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[{"$match": {
                  "$and": [
                    {"$or": [
                      {"status": "ACTIVE"},
                      {"status": "PENDING"},
                      {"status": "FINISHED"},
                      {"status": "STOPPED"}
                    ]},
                    {"companyId": "${corporateId}"}
                    ]
                }}${limit ? limitedString(limit) : ""}${
        page ? paginationString(page) : ""
      }]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterPlacementVacancy = async (
  filters?: {
    status?: string;
    managedBy?: string;
  },
  onlySize?: boolean,
  page?: number,
  limit?: number,
  sortBy?: string,
  asc?: boolean,
): Promise<PlacementVacancyWithCorporateData[] | null> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
        {"$match": {
          "$and": [
            {"status": { "$ne": "DISABLED" }}
            ${filters?.status ? `,{"status": "${filters?.status}"}` : ""} 
            ${
              filters?.managedBy
                ? `,{"managedBy": "${filters?.managedBy}"}`
                : ""
            } 
          ]
        }},
        {"$addFields": {
          "objectCompanyId": {
            "$convert": {
              "input": "$companyId",
              "to":"objectId",
              "onError": "",
              "onNull":""
            }
          }
        }},
        {"$addFields": {
            "id": {"$toString": "$_id"},
        }},
        {"$lookup": {
            "from": "analytics",
            "localField": "id",
            "foreignField": "entityId",
            "as": "clicks"
        }},
        {"$lookup": {
            "from": "placementVacancySubscription",
            "localField": "id",
            "foreignField": "placementVacancyId",
            "pipeline": [
              {
                "$match": { "status": { "$ne": "NONE" } },
              },
            ],
            "as": "subscriptions"
        }},
        {"$addFields": {
            "subscriptions": {
              "$size": "$subscriptions"
            },
            "clicks": {
              "$size": "$clicks"
            }
        }},
        {"$lookup": {
            "from": "company",
            "localField": "objectCompanyId",
            "foreignField": "_id",
            "as": "companyData"
        }},
        {"$unwind": {
          "path": "$companyData",
        }},
        {"$addFields":{
          "companyName": "$companyData.profile.name",
          "photo": "$companyData.profile.logo",
          "companyWebsite": "$companyData.profile.site",
          "companyAbout": "$companyData.profile.description",
        }},
        {"$project": {
          "companyData": 0,
          "objectCompanyId": 0
        }}
        ${onlySize ? onlySizeQuery() : ""}
        ${sortBy ? sortString(sortBy, asc) : ""}
        ${page ? paginationString(page) : ""}
        ${limit ? limitedString(limit) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getAllPlacementVacancyWithCorporateData = async (
  filters?: {
    managedBy?: string[];
  },
  onlySize = false,
  page?: number,
): Promise<PlacementVacancyWithCorporateData[] | null> => {
  let managedByString = "[";
  filters?.managedBy?.forEach((item, index) => {
    managedByString += `${index ? "," : ""}"${item}"`;
    return managedByString;
  });
  managedByString += "]";

  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
        {"$match": 
          {
            "$and": [
              {
                "$or": [
                  {"status": "ACTIVE"},
                  {"status": "PENDING"}
                ]
              }
              ${
                filters?.managedBy
                  ? `,{"managedBy": {"$in": ${managedByString}}}`
                  : ""
              }
            ]
          }
        },
        {"$addFields": {
          "objectCompanyId": {
            "$convert": {
              "input": "$companyId",
              "to":"objectId",
              "onError": "",
              "onNull":""
            }
          }
        }},
        {"$lookup": {
            "from": "company",
            "localField": "objectCompanyId",
            "foreignField": "_id",
            "as": "companyData"
        }},
        {"$unwind": {
          "path": "$companyData",
        }},
        {"$addFields":{
          "companyName": "$companyData.profile.name",
          "photo": "$companyData.profile.logo",
          "companyWebsite": "$companyData.profile.site",
          "companyAbout": "$companyData.profile.description",
        }},
        {"$project": {
          "companyData": 0,
          "objectCompanyId": 0
        }}
        ${onlySize ? onlySizeQuery() : ""}
        ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getPlacementVacancyWithCorporateData = async (
  placementId: string,
): Promise<PlacementVacancyWithCorporateData[] | null> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
    {
        "$addFields": {
            "objectPlacementId": {
                "$convert":
      {
         "input": "${placementId}",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
            }
        }
    },
    {
        "$match": {
            "$expr": {
                "$eq": [
                    "$_id",
                    "$objectPlacementId"
                ]
            }
        }
    },
    {
        "$addFields": {
            "objectCompanyId": {
                "$convert":
      {
         "input": "$companyId",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
            }
        }
    },
    {
        "$lookup": {
            "from": "company",
            "localField": "objectCompanyId",
            "foreignField": "_id",
            "as": "companyData"
        }
    },
    {
        "$unwind": {
            "path": "$companyData",
        }
    },
    {
        "$addFields": {
            "companyName": "$companyData.profile.name",
            "photo": "$companyData.profile.logo",
            "companyWebsite": "$companyData.profile.site",
            "companyAbout": "$companyData.profile.description",
        }
    },
    {
        "$project": {
            "companyData": 0,
            "objectCompanyId": 0
        }
    }]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const createVacancy = async (
  vacancy: PlacementVacancy,
): Promise<boolean> => {
  try {
    const response = await api
      .post("/placementVacancy", vacancy)
      .then((res) => {
        logDetails(res.config?.url ?? "", "createVacancy", "success", vacancy);
        return res;
      })
      .catch((res) =>
        logDetails(res.config?.url ?? "", "createVacancy", "error"),
      );

    if (
      response?.data &&
      vacancy?.managedBy !== placementVacancyManagedBy.EXTERNAL_VACANCY
    ) {
      if (vacancy.typeOfCandidature === "OPEN")
        await newPublicUserVacancy(response?.data?._id ?? "");
      else await newPrivateUserVacancy(response?.data?._id ?? "");
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateVacancyById = async (
  vacancyId: string,
  vacancy: PlacementVacancy,
  status?: keyof typeof placementVacancyStatus,
): Promise<boolean> => {
  try {
    await api
      .patch(`/placementVacancy/${vacancyId}`, vacancy)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateVacancyById",
          "success",
          vacancy,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "updateVacancyById", "error"),
      );

    switch (status) {
      case placementVacancyStatus.PENDING:
        await stoppedUserVacancy(vacancy._id ?? "");
        break;

      case placementVacancyStatus.FINISHED:
        await finishedUserVacancy(vacancy._id ?? "");
        break;

      case placementVacancyStatus.ACTIVE:
        await reactivateUserVacancy(vacancy._id ?? "");
        break;

      default:
        await updatedUserVacancy(vacancyId);
    }

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const getSavedVacanciesPerUser = async (
  userId: string,
): Promise<PlacementVacancySubscriptionWithVacancyData[] | null> => {
  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[
        {"$match": {
          "$and": [
            {"saved": true},
            {"userId": "${userId}"}
          ]
        }},
        {"$addFields":{
          objectPlacementVacancyId: {
            "$convert":
      {
         "input": "$placementVacancyId",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
          }
        }},
        {"$lookup": {
          "from": "placementVacancy",
          "localField": "objectPlacementVacancyId",
          "foreignField": "_id",
          "as": "placementVacancyData"
        }},
        {"$unwind": {
          "path": "$placementVacancyData",
        }},
        {"$addFields":{
          "objectCompanyId": {
            "$convert":
      {
         "input": "$placementVacancyData.companyId",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
          }
        }},
        {"$lookup": {
          "from": "company",
          "localField": "objectCompanyId",
          "foreignField": "_id",
          "as": "companyData"
        }},
        {"$unwind": {
          "path": "$companyData",
        }},
        {"$project": {
          "objectPlacementVacancyId": 0,
          "objectCompanyId": 0,
        }}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const vacanciesPerUser = async (
  userId: string,
  status?: keyof typeof placementVacancySubscriptionStatus,
  page?: number,
): Promise<PlacementVacancySubscriptionWithVacancyData[] | null> => {
  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[
        {"$match": {
          "$and": [
            ${
              status
                ? `{"status": "${status}"},`
                : '{"$or": [{"status":"APPROVED"}, {"status" : "DISAPPROVED"}, {"status": "NONE"}]},'
            }
            {"userId": "${userId}"},
          ]
        }},
        {"$addFields":{
          objectPlacementVacancyId: {
            "$convert":
      {
         "input": "$placementVacancyId",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
          }
        }},
        {"$lookup": {
            "from": "placementVacancy",
            "localField": "objectPlacementVacancyId",
            "foreignField": "_id",
            "as": "placementVacancyData"
        }},
        {"$unwind": {
          "path": "$placementVacancyData",
        }},
        {"$addFields":{
          "objectCompanyId": {
            "$convert":
      {
         "input": "$placementVacancyData.companyId",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
          }
        }},
        {"$lookup": {
            "from": "company",
            "localField": "objectCompanyId",
            "foreignField": "_id",
            "as": "companyData"
        }},
        {"$unwind": {
          "path": "$companyData",
        }},
        {"$project": {
          "objectPlacementVacancyId": 0,
          "objectCompanyId": 0,
        }}${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

const getVacancyStageId = async (
  vacancyId: string,
  order = 0,
): Promise<string | undefined> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
        {"$addFields": {
          "objectVacancyId": {
            "$convert":
      {
         "input": "${vacancyId}",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
          }
        }},
        {"$match": {
          "$expr": { "$eq": [
          "$_id", '$objectVacancyId']}
        }}]`,
    });
    const element: PlacementVacancy = response.data[0];
    return element?.stages?.find((i) => i.order === order)?.id;
  } catch (error) {
    console.warn(error);
    return undefined;
  }
};

/* VACANCY SUBSCRIPTION */

export const isSubscriptedThisVacancy = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[{"$match": {
              "$and": [
                {"status": "IN_PROCESS"},
                {"userId": "${userId}" },
                {"placementVacancyId": "${vacancyId}" },
              ]
            }},{"$project" : {"return": true}}]`,
    });
    return response.data?.length > 0;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

const getVacancySubscriptionId = async (
  vacancyId: string,
  userId: string,
): Promise<string | null> => {
  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[{"$match": {
              "$and": [
                {"userId": "${userId}" },
                {"placementVacancyId": "${vacancyId}" },
              ]
            }}]`,
    });
    return response.data[0]?._id;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

const getAllPlacementVacancySubscriptionStages = async (
  vacancySubscriptionId: string,
): Promise<PlacementVacancySubscriptionStages[] | null> => {
  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[
        {"$addFields": {
          "objectVacancySubscriptionId": {
            "$convert":
      {
         "input": "${vacancySubscriptionId}",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
          }
        }},
        {"$match": {
          "$expr": { "$eq": [
          "$_id", '$objectVacancySubscriptionId']}
        }}]`,
    });
    const stage: PlacementVacancySubscriptionStages[] = response.data[0].stages;
    return stage;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getAllSubscriptionsOfAVacancy = async (
  vacancyId: string,
  onlySize = false,
  page?: number,
  sortBy = "userName",
  asc = true,
): Promise<PlacementVacancySubscription[] | null> => {
  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[
          {
            "$match": {
              "placementVacancyId": "${vacancyId}"
            }
          },
          {
            "$addFields": {
              "objectUserId": {
                "$convert": {
                  "input": "$userId",
                  "to": "objectId",
                  "onError": null,
                  "onNull": null
                }
              }
            }
          },
          {
            "$lookup": {
              "from": "user",
              "localField": "objectUserId",
              "foreignField": "_id",
              "as": "userData"
            }
          },
          {
            "$unwind": {
              "path": "$userData"
            }
          },
          {
            "$addFields": {
              "objectPlacementVacancyId": {
                "$convert": {
                  "input": "$placementVacancyId",
                  "to": "objectId",
                  "onError": null,
                  "onNull": null
                }
              }
            }
          },
          {
            "$lookup": {
              "from": "placementVacancy",
              "localField": "objectPlacementVacancyId",
              "foreignField": "_id",
              "as": "placementVacancyData"
            }
          },
          {
            "$unwind": {
              "path": "$placementVacancyData"
            }
          },
          {
            "$addFields": {
              "id": "$userData._id",
              "vacancyName": "$placementVacancyData.title",
              "vacancyPlace": "$placementVacancyData.place",
              "userName": "$userData.profile.name",
              "userPhoto": "$userData.profile.photo",
              "lastStage": {
                "$last": {
                  "$filter": {
                    "input": "$placementVacancyData.stages",
                    "as": "item",
                    "cond": {
                      "$eq": [
                        "$$item.id",
                        { "$last": "$stages.stageId" }
                      ]
                    }
                  }
                }
              }
            }
          },
          {
            "$project": {
              "userData": 0,
              "placementVacancyData": 0,
              "objectUserId": 0,
              "objectPlacementVacancyId": 0
            }
          }
          ${onlySize ? onlySizeQuery() : ""}
          ${sortBy ? sortString(sortBy, asc) : ""}
          ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getMessagesBySubscriptionsOfAVacancy = async (
  vacancyId: string,
  companyId: string,
): Promise<PlacementVacancySubscription[] | null> => {
  try {
    const users = await getUserByCompanyId(companyId);
    const userIds = users?.map((item) => item?._id);
    let userIdString = "[";
    userIds?.forEach((item, index) => {
      userIdString += `${index ? "," : ""}"${item}"`;
      return userIdString;
    });
    userIdString += "]";

    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[
          {
            "$match": {
              "$and": [
                {"placementVacancyId": "${vacancyId}"},
                {"$nor": [{"messages": {"$exists":false}}, {"messages":{"$size":0}}]}
              ]
            }
          },
          {
            "$project": {
              "userId": 1,
              "messages": { "$last": "$messages" },
            },
          },
          {
            "$match": {
              "messages.userId": {
                "$nin": ${userIdString},
              },
            },
          },
          {
            "$addFields": {
              "objectUserId": {
                "$convert": {
                  "input": "$userId",
                  "to": "objectId",
                  "onError": null,
                  "onNull": null,
                },
              },
            },
          },
          {
            "$lookup": {
              "from": "user",
              "localField": "objectUserId",
              "foreignField": "_id",
              "as": "userData",
            },
          },
          {
            $"unwind": {
              "path": "$userData",
            },
          },
          {
            $"project": {
              "messages": 1,
              "name": "$userData.profile.name",
              "photo": "$userData.profile.photo",
            },
          },
        ]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const changeVacancySubscription = async (
  subscriptionId: string,
  vacancySubscription: PlacementVacancySubscription,
): Promise<boolean> => {
  try {
    await api
      .patch(
        `/placementVacancySubscription/${subscriptionId}`,
        vacancySubscription,
      )
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "changeVacancySubscription",
          "success",
          vacancySubscription,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "changeVacancySubscription", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const isSavedThisVacancy = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[{"$match": {
              "$and": [
                {"saved": true},
                {"userId": "${userId}" },
                {"placementVacancyId": "${vacancyId}" },
              ]
            }},{"$project" : {"return": true}}]`,
    });
    return response.data?.length > 0;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const unsubscriptInVacancyById = async (
  subscriptionId: string,
): Promise<boolean> => {
  try {
    const data = {
      endDate: date,
      status: "NONE",
    };

    await api
      .patch(`/placementVacancySubscription/${subscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "unsubscriptInVacancyById",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "unsubscriptInVacancyById", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const unsubscriptInVacancy = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const subscriptionId = await getVacancySubscriptionId(vacancyId, userId);
    if (subscriptionId) {
      const data = {
        endDate: date,
        placementVacancyId: vacancyId,
        userId,
        status: "NONE",
      };

      await api
        .patch(`/placementVacancySubscription/${subscriptionId}`, data)
        .then((res) =>
          logDetails(
            res.config?.url ?? "",
            "unsubscriptInVacancy",
            "success",
            data,
          ),
        )
        .catch((res) =>
          logDetails(res.config?.url ?? "", "unsubscriptInVacancy", "error"),
        );
      return false;
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const subscriptInVacancy = async (
  vacancyId: string,
  userId: string,
  greenhouseReference?: string | null,
  gupyReference?: string | null,
): Promise<boolean> => {
  try {
    const subscriptionId = await getVacancySubscriptionId(vacancyId, userId);
    const stageId = await getVacancyStageId(vacancyId);
    if (subscriptionId) {
      const stages = await getAllPlacementVacancySubscriptionStages(
        subscriptionId,
      );

      const otherStages = stages?.filter((i) => i.order !== 0) ?? [];
      const zeroStage = stages?.find((i) => i.order === 0);

      const data = {
        startDate: date,
        placementVacancyId: vacancyId,
        userId,
        status: "IN_PROCESS",
        isInvited: false,
        greenhouseReference,
        gupyReference,
        stages: [
          {
            ...zeroStage,
            stageId,
            startDate: zeroStage?.startDate ?? date,
            status: zeroStage?.status ?? "IN_PROCESS",
            order: zeroStage?.order ?? 0,
          },
          ...otherStages.sort((a, b) => a.order - b.order),
        ],
      };

      await api
        .patch(`/placementVacancySubscription/${subscriptionId}`, data)
        .then((res) =>
          logDetails(
            res.config?.url ?? "",
            "updateSubscriptInVacancy",
            "success",
            data,
          ),
        )
        .catch((res) =>
          logDetails(
            res.config?.url ?? "",
            "updateSubscriptInVacancy",
            "error",
          ),
        );
    } else {
      const data = {
        startDate: date,
        placementVacancyId: vacancyId,
        userId,
        status: "IN_PROCESS",
        isInvited: false,
        stages: [
          {
            stageId,
            startDate: date,
            status: "IN_PROCESS",
            order: 0,
          },
        ],
      };

      await api
        .post("/placementVacancySubscription", data)
        .then((res) =>
          logDetails(
            res.config?.url ?? "",
            "createSubscriptInVacancy",
            "success",
            data,
          ),
        )
        .catch((res) =>
          logDetails(
            res.config?.url ?? "",
            "createSubscriptInVacancy",
            "error",
          ),
        );
    }
    await subcribeUserVacancy(userId, vacancyId);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateAVacancy = async (
  vacancyId: string,
  userId: string,
  vacancy: PlacementVacancySubscription,
): Promise<boolean> => {
  try {
    const subscriptionId = await getVacancySubscriptionId(vacancyId, userId);
    if (subscriptionId) {
      await api
        .patch(`/placementVacancySubscription/${subscriptionId}`, vacancy)
        .then((res) =>
          logDetails(
            res.config?.url ?? "",
            "updateAVacancy",
            "success",
            vacancy,
          ),
        )
        .catch((res) =>
          logDetails(res.config?.url ?? "", "updateAVacancy", "error"),
        );
      return true;
    }
    return false;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const upVacancyStage = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const subscriptionId =
      (await getVacancySubscriptionId(vacancyId, userId)) ?? "";

    const subscriptionStages = await getAllPlacementVacancySubscriptionStages(
      subscriptionId,
    );

    const lastSubscriptionStageOrder = subscriptionStages?.sort(
      (a, b) => b.order - a.order,
    )[0].order;

    const vacancy = await getPlacementVacancy(vacancyId);

    const lastVacancyStage = vacancy?.stages?.sort(
      (a: { order: number }, b: { order: number }) => b.order - a.order,
    )[0].order;

    const filteredSubscriptionStages =
      subscriptionStages?.map((i) => {
        if (i.order !== lastSubscriptionStageOrder) return i;
        return {
          ...i,
          status: "APPROVED",
          endDate: date,
        };
      }) ?? [];
    const isLastStage = lastVacancyStage === lastSubscriptionStageOrder;

    if (isLastStage) {
      // not next, is the last one
      const data = {
        status: "APPROVED",
        stages: [
          ...filteredSubscriptionStages.sort((a, b) => a.order - b.order),
        ],
      };
      await api
        .patch(`/placementVacancySubscription/${subscriptionId}`, data)
        .then((res) =>
          logDetails(
            res.config?.url ?? "",
            "approvedUpVacancyStage",
            "success",
            data,
          ),
        )
        .catch((res) =>
          logDetails(res.config?.url ?? "", "approvedUpVacancyStage", "error"),
        );
    } else {
      const order = lastSubscriptionStageOrder
        ? lastSubscriptionStageOrder + 1
        : 1;

      const stageId = vacancy?.stages
        ? vacancy?.stages?.find((i: { order: number }) => i.order === order)
            ?.id ??
          vacancy?.stages?.find((i: { order: number }) => i.order === 1000)?.id
        : null;

      const data = {
        status: "IN_PROCESS",
        stages: [
          ...filteredSubscriptionStages.sort((a, b) => a.order - b.order),
          {
            stageId,
            startDate: date,
            status: "IN_PROCESS",
            order,
          },
        ],
      };

      await api
        .patch(`/placementVacancySubscription/${subscriptionId}`, data)
        .then((res) =>
          logDetails(res.config?.url ?? "", "upVacancyStage", "success", data),
        )
        .catch((res) =>
          logDetails(res.config?.url ?? "", "upVacancyStage", "error"),
        );
    }
    await nextStepUserVacancy(userId, vacancyId);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const downVacancyStage = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const subscriptionId =
      (await getVacancySubscriptionId(vacancyId, userId)) ?? "";
    const subscriptionStages = await getAllPlacementVacancySubscriptionStages(
      subscriptionId,
    );
    const lastSubscriptionStageOrder = subscriptionStages?.sort(
      (a, b) => b.order - a.order,
    )[0]?.order;
    const filteredSubscriptionStages =
      subscriptionStages?.filter(
        (i) => i.order !== lastSubscriptionStageOrder,
      ) ?? [];
    const orderedSubscriptionStages = filteredSubscriptionStages.map((i) => {
      if (
        lastSubscriptionStageOrder &&
        i.order !== lastSubscriptionStageOrder - 1
      )
        return i;
      return {
        ...i,
        endDate: null,
        status: "IN_PROCESS",
      };
    });

    const data = {
      status: "IN_PROCESS",
      stages: [...orderedSubscriptionStages.sort((a, b) => a.order - b.order)],
    };
    await api
      .patch(`/placementVacancySubscription/${subscriptionId}`, data)
      .then((res) =>
        logDetails(res.config?.url ?? "", "downVacancyStage", "success", data),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "downVacancyStage", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const rejectUserFromVacancyStage = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const subscriptionId =
      (await getVacancySubscriptionId(vacancyId, userId)) ?? "";
    const stages = await getAllPlacementVacancySubscriptionStages(
      subscriptionId,
    );
    const filteredStages =
      stages?.map((i) => {
        if (i.status !== "IN_PROCESS")
          return {
            ...i,
            status: "APPROVED",
            endDate: i.endDate ?? date,
          };

        return {
          ...i,
          status: "DISAPPROVED",
          endDate: date,
        };
      }) ?? [];

    const data = {
      status: "DISAPPROVED",
      endDate: date,
      stages: [...filteredStages.sort((a, b) => a.order - b.order)],
    };
    await api
      .patch(`/placementVacancySubscription/${subscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "rejectUserFromVacancyStage",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "rejectUserFromVacancyStage",
          "error",
        ),
      );

    await disapprovedUserVacancy(userId, vacancyId);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const restoreRejectedUser = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const subscriptionId =
      (await getVacancySubscriptionId(vacancyId, userId)) ?? "";
    const stages = await getAllPlacementVacancySubscriptionStages(
      subscriptionId,
    );
    const filteredStages =
      stages
        ?.map((i) => {
          if (i.status === "DISAPPROVED")
            return {
              ...i,
              status: "IN_PROCESS",
              endDate: null,
            };

          return i;
        })
        ?.sort((a, b) => a.order - b.order) ?? [];

    const data = {
      status: "IN_PROCESS",
      endDate: null,
      stages: [...filteredStages],
    };
    await api
      .patch(`/placementVacancySubscription/${subscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "restoreRejectedUser",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "restoreRejectedUser", "error"),
      );

    await reactivatedUserVacancy(userId, vacancyId);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const saveAVacancy = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const subscriptionId = await getVacancySubscriptionId(vacancyId, userId);

    const data = {
      startDate: date,
      placementVacancyId: vacancyId,
      userId,
      saved: true,
      status: "NONE",
      isInvited: false,
    };

    if (subscriptionId)
      await api
        .patch(`/placementVacancySubscription/${subscriptionId}`, {
          saved: true,
        })
        .then((res) =>
          logDetails(res.config?.url ?? "", "updateSaveAVacancy", "success", {
            saved: true,
          }),
        )
        .catch((res) =>
          logDetails(res.config?.url ?? "", "updateSaveAVacancy", "error"),
        );
    else
      await api
        .post("/placementVacancySubscription", data)
        .then((res) =>
          logDetails(
            res.config?.url ?? "",
            "createSaveAVacancy",
            "success",
            data,
          ),
        )
        .catch((res) =>
          logDetails(res.config?.url ?? "", "createSaveAVacancy", "error"),
        );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const unsaveAVacancy = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const subscriptionId = await getVacancySubscriptionId(vacancyId, userId);
    if (subscriptionId) {
      await api
        .patch(`/placementVacancySubscription/${subscriptionId}`, {
          saved: false,
        })
        .then((res) =>
          logDetails(res.config?.url ?? "", "unsaveAVacancy", "success", {
            saved: false,
          }),
        )
        .catch((res) =>
          logDetails(res.config?.url ?? "", "unsaveAVacancy", "error"),
        );
      return true;
    }
    return false;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const sendInviteToUser = async (
  vacancyId: string,
  userId: string,
  text?: string,
  sendId?: string,
): Promise<boolean> => {
  try {
    const vacancySubscriptionId = await getVacancySubscriptionId(
      vacancyId,
      userId,
    );

    if (vacancySubscriptionId) {
      const isSubscripted = await isSubscriptedThisVacancy(vacancyId, userId);
      if (!isSubscripted) {
        const payload: PlacementVacancySubscription = {
          startDate: date,
          placementVacancyId: vacancyId,
          userId,
          status: placementVacancySubscriptionStatus.PENDING,
          isInvited: true,
          messageToInvite: {
            userId: sendId ?? "",
            date,
            text: text ?? "",
          },
        };

        await api
          .patch(
            `/placementVacancySubscription/${vacancySubscriptionId}`,
            payload,
          )
          .then((res) =>
            logDetails(
              res.config?.url ?? "",
              "updateSendInviteToUser",
              "success",
              payload,
            ),
          )
          .catch((res) =>
            logDetails(
              res.config?.url ?? "",
              "updateSendInviteToUser",
              "error",
            ),
          );

        await notifyUserInvite(userId, vacancyId);
      } else {
        return false;
      }
    } else {
      const payload = {
        startDate: date,
        placementVacancyId: vacancyId,
        userId,
        status: placementVacancySubscriptionStatus.PENDING,
        isInvited: true,
        messageToInvite: {
          userId: sendId,
          date,
          text: text ?? "",
        },
      };

      await api
        .post("/placementVacancySubscription", payload)
        .then((res) =>
          logDetails(
            res.config?.url ?? "",
            "createSendInviteToUser",
            "success",
            payload,
          ),
        )
        .catch((res) =>
          logDetails(res.config?.url ?? "", "createSendInviteToUser", "error"),
        );

      await notifyUserInvite(userId, vacancyId);
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* INTEGRATIONS */

const getGHCredentials = async (
  jobId: string,
): Promise<{ auth: string; email: string }> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
        {
          "$match": {
            "$expr": {
              "$eq": [
                "$_id", {
                  "$convert":
      {
         "input": "${jobId}",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
                }
              ]
            }
          }
        }, {
          "$project": {
            "company": {
              "$convert":
      {
         "input": "$companyId",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
            }
          }
        }, {
          "$lookup": {
            "from": "company", 
            "localField": "company", 
            "foreignField": "_id", 
            "as": "company"
          }
        }, {
          "$unwind": {
            "path": "$company"
          }
        }, {
          "$project": {
            "integrations": "$company.integrations"
          }
        }, {
          "$unwind": {
            "path": "$integrations"
          }
        }, {
          "$match": {
            "integrations.platform": "GREENHOUSE"
          }
        },
        {
          "$project": {
            "email":"$integrations.user",
            "auth": "$integrations.token"
          }
        }
      ]`,
    });
    return response?.data[0];
  } catch {
    return { auth: "", email: "" };
  }
};

const getGupyCredentials = async (
  jobId: string,
): Promise<{ auth: string; email: string }> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
        {
          "$match": {
            "$expr": {
              "$eq": [
                "$_id", {
                  "$convert":
      {
         "input": "${jobId}",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
                }
              ]
            }
          }
        }, {
          "$project": {
            "company": {
              "$convert":
      {
         "input": "$companyId",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
            }
          }
        }, {
          "$lookup": {
            "from": "company", 
            "localField": "company", 
            "foreignField": "_id", 
            "as": "company"
          }
        }, {
          "$unwind": {
            "path": "$company"
          }
        }, {
          "$project": {
            "integrations": "$company.integrations"
          }
        }, {
          "$unwind": {
            "path": "$integrations"
          }
        }, {
          "$match": {
            "integrations.platform": "GUPY"
          }
        },
        {
          "$project": {
            "email":"$integrations.user",
            "auth": "$integrations.token"
          }
        }
      ]`,
    });
    return response?.data[0];
  } catch {
    return { auth: "", email: "" };
  }
};

// TODO: remover bootcamps[0]?.skill
export const candidateOnGreenhouse = async (
  user: any,
  jobId: string,
  partnerVacancyId: string | number,
): Promise<boolean> => {
  try {
    const body = {
      prospect: false,
      first_name: user?.profile?.name?.split(" ")[0] ?? "",
      last_name:
        user?.profile?.name?.split(user?.profile?.name?.split(" ")[0])[1] ?? "",
      title: `Programadora ${user?.bootcamps[0]?.skill ?? ""}`,
      notes: `Perfil em: ${window.location.hostname}/profile/${user?._id}
      ${
        user?.curriculum?.skills
          ? `\nLista de habilidades da candidata: ${user?.curriculum?.skills
              ?.map((i: { key: string }) => i.key)
              ?.join(", ")}`
          : ""
      }`,
      phone_numbers: [
        {
          phone_number: user?.profile?.telephone,
          type: "mobile",
        },
      ],
      emails: [
        {
          email: user?.profile?.email ?? user?.login?.identification,
          type: "personal",
        },
      ],
      social_media: user?.profile?.socialMedias?.map((i: { url: any }) => ({
        url: i.url ?? `${window.location.hostname}/profile/${user?._id}`,
      })),
      websites: user?.curriculum?.portfolios?.map((i: { url: string }) => ({
        url: i?.url ?? `${window.location.hostname}/profile/${user?._id}`,
        type: "portfolio",
      })),
      addresses: [
        {
          address: `${user?.profile?.address?.address}, ${user?.profile?.address?.number} ${user?.profile?.address?.adjunct}. Bairro ${user?.profile?.address?.district}, ${user?.profile?.address?.city}/${user?.profile?.address?.province}. CEP: ${user?.profile?.address?.zipCode}`,
          type: "home",
        },
      ],
      job_id: parseInt(partnerVacancyId.toString(), 10),
      external_id: user?._id,
    };
    const { auth, email } = await getGHCredentials(jobId);
    const aditionalHeaders = { auth, user: email };
    const insertion = await api.post("/greenhouse", body, {
      headers: aditionalHeaders,
    });
    const greenhouseRef = insertion.data.id;
    await subscriptInVacancy(jobId, user._id, greenhouseRef);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

interface requestPost {
  currentStepId?: number;
  notes?: string;
  manualCandidate: {
    name: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    linkedinProfileUrl: string;
    insertionSource:
      | "candidate_active_contact"
      | "events"
      | "hunting"
      | "market_referral_consulting"
      | "employee_referral"
      | "chrome_extension";
  };
}

export const candidateOnGupy = async (
  user: any,
  jobId: string,
): Promise<boolean> => {
  try {
    const body: requestPost = {
      notes: `Link do perfil na plataforma reprograma: https://app.reprograma.com.br/profile/${user._id}`,
      manualCandidate: {
        name: user?.profile?.name?.split(" ")[0] ?? "",
        lastName:
          user?.profile?.name?.split(user?.profile?.name?.split(" ")[0])[1] ??
          "",
        email: user?.profile?.email ?? user?.login?.identification,
        mobileNumber: user?.profile?.telephone,
        linkedinProfileUrl:
          user?.profile?.socialMedias?.find(
            (i: { type: string }) => i.type === "LINKEDIN",
          ) ?? "",
        insertionSource: "market_referral_consulting",
      },
    };

    const { auth, email } = await getGupyCredentials(jobId);
    const aditionalHeaders = { auth, user: email };
    const insertion = await api.post("/gupy", body, {
      headers: aditionalHeaders,
    });
    const gupyRef = insertion.data.id;
    await subscriptInVacancy(jobId, user._id, null, gupyRef);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const getIntegrations = async (
  companyId: string,
): Promise<Integration[] | null> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: `[
        {
          "$match": {
            "$expr": {
              "$eq": [
                "$_id", {
                  "$convert":
      {
         "input": "${companyId}",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
                }
              ]
            }
          }
        }, {
          "$project": {
            "platform": "$integrations.platform",
            "token": "$integrations.token",
            "user": "$integrations.user"
          }
        }
      ]`,
    });
    return response?.data;
  } catch {
    return null;
  }
};

export const userIsInvitedToVacancy = async (
  vacancyId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[{"$match": {
                "$and": [
                  {"placementVacancyId": "${vacancyId}"},
                  {"userId": "${userId}"},
                  {"isInvited": true},
                ]
              }}]`,
    });
    return !!response?.data?.length;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* AUTOCOMPLETE */

export const getAutocomplete = async (
  type: keyof typeof autoCompleteType,
  status = autoCompleteStatus.ACTIVE,
  page?: number,
): Promise<AutoComplete[] | null> => {
  try {
    const response = await api.post("/get/autocomplete", {
      aggregate: `[{"$match": {"$and":[{"status":"${status}"},{"type": "${type}"}]}}${
        page ? paginationString(page) : ""
      }]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getRegexAutocomplete = async (
  name: string,
  type: keyof typeof autoCompleteType,
  page?: number,
): Promise<AutoComplete[] | null> => {
  try {
    const response = await api.post("/get/autocomplete", {
      aggregate: `[{"$match": {"$and":[{"name":{"$regex": "^${name}$", "$options" : "im"}},{"type": "${type}"}]}}${
        page ? paginationString(page) : ""
      }]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterAutocomplete = async (
  filters?: {
    name?: string;
    status?: string;
    type?: string;
  },
  onlySize?: boolean,
  page?: number,
  limit?: number,
  sortBy?: string,
  asc?: boolean,
): Promise<AutoComplete[] | null> => {
  try {
    const response = await api.post("/get/autocomplete", {
      aggregate: `[{"$match": {
         "$and":[
          {"userSugested":true}
          ${
            filters?.name
              ? `,{"name":{"$regex" : "${filters?.name}", "$options": "im"}}`
              : ""
          }
          ${filters?.status ? `,{"status":"${filters?.status}"}` : ""}
          ${filters?.type ? `,{"type":"${filters?.type}"}` : ""}
        ]}
      }
      ${onlySize ? onlySizeQuery() : ""}
      ${sortBy ? sortString(sortBy, asc) : ""}
      ${page ? paginationString(page) : ""}
      ${limit ? limitedString(limit) : ""}
      ]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const setAutocomplete = async (
  type: keyof typeof autoCompleteType,
  name: string,
  userSugested = true,
  status = autoCompleteStatus.PENDING,
): Promise<boolean> => {
  try {
    const prop: AutoComplete = {
      type,
      name,
      userSugested,
      status,
    };
    await api.post("/autocomplete", prop);
    return true;
  } catch (error) {
    return false;
  }
};

export const updateAutocompleteById = async (
  id: string,
  data: AutoComplete,
): Promise<boolean> => {
  try {
    await api.patch(`/autocomplete/${id}`, data);
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* ADMIN */

export const createUser = async (
  email: string,
  roles: Array<keyof typeof userRoles>,
  classUser = "",
  companyIds: [] | string[] = [],
  tags = [],
): Promise<any> => {
  try {
    let user: any = {
      login: {
        identification: email.toLowerCase().trim(),
      },
      account: {
        roles,
        companyIds,
        tags,
        status: userStatus.PENDING,
      },
      profile: {
        email: email.toLowerCase().trim(),
      },
    };

    if (classUser) user = { ...user, bootcamps: [{ classId: classUser }] };

    const result = await api
      .post("/user", user)
      .then((res) => {
        logDetails(res.config?.url ?? "", "createUser", "success", user);
        return res;
      })
      .catch((res) => logDetails(res.config?.url ?? "", "createUser", "error"));
    return result?.data;
  } catch (error) {
    return false;
  }
};

export const createUserWithPassword = async (
  email: string,
  password: string,
  roles: Array<keyof typeof userRoles>,
  status: keyof typeof userStatus,
  companyId?: string,
): Promise<boolean> => {
  try {
    const user: any = {
      login: {
        identification: email.toLowerCase().trim(),
        password,
      },
      account: {
        roles,
        status,
        companyIds: [companyId],
      },
    };

    await api.post("/create_user", user);
    return true;
  } catch (error) {
    return false;
  }
};

export const createCandidate = async (email: string): Promise<boolean> => {
  try {
    const user: any = {
      login: {
        identification: email.toLowerCase().trim(),
      },
      account: {
        roles: ["CANDIDATE"],
        status: "PENDING",
      },
    };

    await api.post("/create_user_identification", user);
    return true;
  } catch (error) {
    return false;
  }
};

/* FILTERS */

export const getCompanyFilters = async (): Promise<any> => {
  try {
    const response = await api.post("/get/company", {
      aggregate: `[
        {
            "$match": {
                "status": "ACTIVE"
            }
        },
        {
            "$project": {
                "size": "$profile.size",
                "localization" :"$profile.location.city"
            }
        },
        {
            "$unwind": {
                "path": "$localization",
                "preserveNullAndEmptyArrays": true
            }
        },
        {
            "$group": {
                "_id": null,
                "localization": {
                    "$addToSet": "$localization"
                },
                "size": {
                    "$addToSet": "$size"
                }
            }
        }
    ]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserFilters = async (
  searchParams: string | null,
  filters: {
    localization?: string[] | null;
    work?: string[] | null;
    education?: string[] | null;
    skill?: string[] | null;
    language?: string[] | null;
    classId?: string[] | null;
  },
  companyId?: string,
): Promise<any> => {
  try {
    const tempWorks: string[] = [];
    for (const i of filters?.work ?? []) {
      if (i) {
        const temp = await getCompanyByName(i);
        if (temp) tempWorks.push(temp?._id ?? "");
      }
    }

    const tempEducations: string[] = [];
    for (const i of filters?.education ?? []) {
      if (i) {
        const temp = await getCompanyByName(i);
        if (temp) tempEducations.push(temp?._id ?? "");
      }
    }

    let educationString = "[";
    tempEducations?.forEach((item, index) => {
      educationString += `${index ? "," : ""}"${item}"`;
      return educationString;
    });
    educationString += "]";

    let workString = "[";
    tempWorks?.forEach((item, index) => {
      workString += `${index ? "," : ""}"${item}"`;
      return workString;
    });
    workString += "]";

    let localizationString = "[";
    filters?.localization?.forEach((item, index) => {
      localizationString += `${index ? "," : ""}"${item}"`;
      return localizationString;
    });
    localizationString += "]";

    let skillString = "[";
    filters?.skill?.forEach((item, index) => {
      skillString += `${index ? "," : ""}"${item}"`;
      return skillString;
    });
    skillString += "]";

    let languageString = "[";
    filters?.language?.forEach((item, index) => {
      languageString += `${index ? "," : ""}"${item}"`;
      return languageString;
    });
    languageString += "]";

    let classString = "[";
    filters?.classId?.forEach((item, index) => {
      classString += `${index ? "," : ""}"${item}"`;
      return classString;
    });
    classString += "]";

    const response = await api.post("/get/user", {
      aggregate: `[
        {
          "$match": {
            "$and": [
              {
                "account.roles": {
                  "$in": [
                    "STUDENT"
                  ]
                }
              },
              {
                "account.status": "ACTIVE"
              }
              ${
                searchParams
                  ? `,{"profile.name": {"$regex" : "${searchParams}", "$options": "im"}}`
                  : ""
              }
              ${
                filters?.localization
                  ? `,{"profile.address.city": {"$in" : ${localizationString} }}`
                  : ""
              }
              ${
                filters?.classId
                  ? `,{"bootcamps.classId": {"$in" : ${classString} }}`
                  : ""
              }
            ]
          }
        }${companyId ? userRestrictions(companyId) : ""}
        ${
          filters?.work
            ? `,{"$addFields": {
            "validWork": {
              "$cond": [
                {
                  "$gte": [
                    {
                        "$size": {
                            "$ifNull": [
                                {
                                    "$filter": {
                                        "input": "$curriculum.works",
                                        "as": "item",
                                        "cond": {
                                            "$and": [
                                                {
                                                    "$eq": [
                                                        "$$item.endDate",
                                                        null
                                                    ]
                                                },
                                                {
                                                    "$in": [
                                                        "$$item.companyId",
                                                        ${workString}
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                []
                            ]
                        }
                    }, 1
                  ]
                }, true, false
              ]
            }
          }
        }, {
          "$match": {
            "$and": [
              {
                "validWork": true
              }
            ]
          }
        }`
            : ""
        }
        ${
          filters?.education
            ? `,{"$addFields": {
          "validEducation": {
            "$cond": [
              {
                "$gte": [
                    {
                        "$size": {
                            "$ifNull": [
                                {
                                    "$filter": {
                                        "input": "$curriculum.educations",
                                        "as": "item",
                                        "cond": {
                                          "$in": [
                                              "$$item.companyId",
                                              ${educationString}
                                          ]
                                        }
                                    }
                                },
                                []
                            ]
                        }
                    }, 1
                ]
              }, true, false
            ]
          }
        }
      }, {
        "$match": {
          "$and": [{
              "validEducation": true
            }
          ]
        }
      }`
            : ""
        }
        ${
          filters?.skill
            ? `,{"$addFields": {
            "validSkill": {
              "$cond": [
                {
                  "$gte": [
                    {
                        "$size": {
                            "$ifNull": [
                                {
                                    "$filter": {
                                        "input": "$curriculum.skills",
                                        "as": "item",
                                        "cond": {
                                                "$in": [
                                                    "$$item.key",
                                                    ${skillString}
                                                ]
                                        }
                                    }
                                },
                                []
                            ]
                        }
                    }, 1
                  ]
                }, true, false
              ]
            }
          }
        }, {
          "$match": {
            "$and": [
              {
                "validSkill": true
              }
            ]
          }
        }`
            : ""
        }
        ${
          filters?.language
            ? `,{"$addFields": {
            "validLanguage": {
              "$cond": [
                {
                  "$gte": [
                    {
                        "$size": {
                            "$ifNull": [
                                {
                                    "$filter": {
                                        "input": "$curriculum.languages",
                                        "as": "item",
                                        "cond": {
                                              "$in": [
                                                  "$$item.language",
                                                  ${languageString}
                                              ]
                                        }
                                    }
                                },
                                []
                            ]
                        }
                    }, 1
                  ]
                }, true, false
              ]
            }
          }
        }, {
          "$match": {
            "$and": [
              {
                "validLanguage": true
              }
            ]
          }
        }`
            : ""
        }, {
          "$project": {
            "city": "$profile.address.city",
            "work": "$curriculum.works",
            "education": "$curriculum.educations",
            "skill": "$curriculum.skills.key",
            "language": "$curriculum.languages.language",
            "class": "$bootcamps.classId"
          }
        }, {
          "$project": {
            "city": 1,
            "class": 1,
            "education": 1,
            "skill" : 1,
            "language" : 1,
            "work": {
              "$filter": {
                "input": "$work",
                "as": "item",
                "cond": {
                  "$eq": [
                    "$$item.endDate", null
                  ]
                }
              }
            }
          }
        }, {
          "$project": {
            "city": 1,
            "work": "$work.companyId",
            "education": "$education.companyId",
            "skill" : 1,
            "language" : 1,
            "class": 1
          }
        }, {
          "$unwind": {
            "path": "$work",
            "preserveNullAndEmptyArrays": true
          }
        }, {
          "$unwind": {
            "path": "$education",
            "preserveNullAndEmptyArrays": true
          }
        }, {
          "$unwind": {
            "path": "$language",
            "preserveNullAndEmptyArrays": true
          }
        }, {
          "$unwind": {
            "path": "$skill",
            "preserveNullAndEmptyArrays": true
          }
        }, {
          "$unwind": {
            "path": "$class",
            "preserveNullAndEmptyArrays": true
          }
        }, {
          "$addFields": {
            "obj_work": {
              "$convert": {
                "input": "$work",
                "to": "objectId",
                "onError": null
              }
            },
            "obj_education": {
              "$convert": {
                "input": "$education",
                "to": "objectId",
                "onError": null
              }
            }
          }
        }, {
          "$lookup": {
            "from": "company",
            "localField": "obj_work",
            "foreignField": "_id",
            "as": "companyW"
          }
        }, {
          "$unwind": {
            "path": "$companyW",
            "preserveNullAndEmptyArrays": true
          }
        }, {
          "$lookup": {
            "from": "company",
            "localField": "obj_education",
            "foreignField": "_id",
            "as": "companyE"
          }
        }, {
          "$unwind": {
            "path": "$companyE",
            "preserveNullAndEmptyArrays": true
          }
        }, {
          "$project": {
            "city": 1,
            "education": "$companyE.profile.name",
            "work": "$companyW.profile.name",
            "class": 1,
            "language": 1,
            "skill": 1
          }
        }, {
          "$group": {
            "_id": null,
            "localization": {
              "$addToSet": "$city"
            },
            "company": {
              "$addToSet": "$work"
            },
            "education": {
              "$addToSet": "$education"
            },
            "class": {
              "$addToSet": "$class"
            },
            "language": {
              "$addToSet": "$language"
            },
            "skill": {
              "$addToSet": "$skill"
            }
          }
        }, {
          "$project": {
            "localization": {
              "$filter": {
                "input": "$localization",
                "as": "d",
                "cond": {
                  "$ne": [
                    "$$d", null
                  ]
                }
              }
            },
            "company": {
              "$filter": {
                "input": "$company",
                "as": "d",
                "cond": {
                  "$ne": [
                    "$$d", null
                  ]
                }
              }
            },
            "education": {
              "$filter": {
                "input": "$education",
                "as": "d",
                "cond": {
                  "$ne": [
                    "$$d", null
                  ]
                }
              }
            },
            "class": {
              "$filter": {
                "input": "$class",
                "as": "d",
                "cond": {
                  "$ne": [
                    "$$d", null
                  ]
                }
              }
            },
            "language": {
              "$filter": {
                "input": "$language",
                "as": "d",
                "cond": {
                  "$ne": [
                    "$$d", null
                  ]
                }
              }
            },
            "skill": {
              "$filter": {
                "input": "$skill",
                "as": "d",
                "cond": {
                  "$ne": [
                    "$$d", null
                  ]
                }
              }
            }
          }
        }
      ]
      `,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getVacancyFilters = async (): Promise<any> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
        {
          "$match": {
            "$or": [
              {
                "status": "ACTIVE"
              }, {
                "status": "PENDING"
              }
            ]
          }
        }, {
          "$addFields": {
            "company": {
              "$convert":
      {
         "input": "$companyId",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
            }
          }
        }, {
          "$lookup": {
            "from": "company",
            "localField": "company",
            "foreignField": "_id",
            "as": "company"
          }
        }, {
          "$unwind": {
            "path": "$company"
          }
        }, {
          "$group": {
            "_id": null,
            "company": {
              "$addToSet": "$company.profile.name"
            },
            "place": {
              "$addToSet": {
                "$cond": [
                  {
                    "$ne": [
                      "$type", "Presencial"
                    ]
                  }, "$type", "$place"
                ]
              }
            },
            "function": {
              "$addToSet": "$title"
            },
            "keys": {
              "$addToSet": "$desiredSkills.key"
            }
          }
        }, {
          "$unwind": {
            "path": "$keys"
          }
        }, {
          "$unwind": {
            "path": "$keys"
          }
        }, {
          "$group": {
            "_id": {
              "company": "$company",
              "place": "$place",
              "function": "$function"
            },
            "keys": {
              "$addToSet": "$keys"
            }
          }
        }, {
          "$project": {
            "company": "$_id.company",
            "place": "$_id.place",
            "function": "$_id.function",
            "key": "$keys",
            "_id": 0
          }
        }
      ]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterUser = async (
  searchParams: string | null,
  filters: {
    anyStatus?: boolean | null;
    localization?: string[] | null;
    work?: string[] | null;
    education?: string[] | null;
    skill?: string[] | null;
    language?: string[] | null;
    classId?: string | null;
    race?: string[] | null;
    genderIdentity?: string[] | null;
    email?: string | null;
    tags?: string | null;
    classStatus?: string | null;
    openForProposals?: boolean | null;
    openForChanges?: boolean | null;
    openForFreelancer?: boolean | null;
  },
  companyId?: string,
  page?: number,
  sortBy?: string,
  asc?: boolean,
  onlySize?: boolean,
): Promise<User[] | { size?: number }[] | null> => {
  try {
    const tempWorks: string[] = [];
    for (const i of filters?.work ?? []) {
      if (i) {
        const temp = await getCompanyByName(i);
        if (temp) tempWorks.push(temp?._id ?? "");
      }
    }

    const tempEducations: string[] = [];
    for (const i of filters?.education ?? []) {
      if (i) {
        const temp = await getCompanyByName(i);
        if (temp) tempEducations.push(temp?._id ?? "");
      }
    }

    let educationString = "[";
    tempEducations?.forEach((item, index) => {
      educationString += `${index ? "," : ""}"${item}"`;
      return educationString;
    });
    educationString += "]";

    let workString = "[";
    tempWorks?.forEach((item, index) => {
      workString += `${index ? "," : ""}"${item}"`;
      return workString;
    });
    workString += "]";

    let localizationString = "[";
    filters?.localization?.forEach((item, index) => {
      localizationString += `${index ? "," : ""}"${item}"`;
      return localizationString;
    });
    localizationString += "]";

    let skillString = "[";
    filters?.skill?.forEach((item, index) => {
      skillString += `${index ? "," : ""}"${item}"`;
      return skillString;
    });
    skillString += "]";

    let languageString = "[";
    filters?.language?.forEach((item, index) => {
      languageString += `${index ? "," : ""}"${item}"`;
      return languageString;
    });
    languageString += "]";

    let raceString = "[";
    filters?.race?.forEach((item, index) => {
      raceString += `${index ? "," : ""}"${item}"`;
      return raceString;
    });
    raceString += "]";

    let genderString = "[";
    filters?.genderIdentity?.forEach((item, index) => {
      genderString += `${index ? "," : ""}"${item}"`;
      return genderString;
    });
    genderString += "]";

    const response = await api.post("/get/user", {
      aggregate: `[
          {
            "$match": {
              "$and": [
                {
                  "account.roles": {
                    "$in": [
                      "STUDENT"
                    ]
                  }
                }
                ${
                  !filters?.anyStatus
                    ? `, {
                        "account.status": "ACTIVE"
                      }`
                    : ""
                }
                ${
                  searchParams
                    ? `, {"profile.name": {"$regex" : "${searchParams}", "$options": "im"}}`
                    : ""
                }
                ${
                  filters?.email
                    ? `, {"profile.email": {"$regex" : "${filters?.email}", "$options": "im"}}`
                    : ""
                }
                ${
                  filters?.race
                    ? `, {"profile.race": {"$in" : ${raceString} }}`
                    : ""
                }
                ${
                  filters?.genderIdentity
                    ? `,{"profile.genderIdentity": {"$in" : ${genderString} }}`
                    : ""
                }
                ${
                  filters?.localization
                    ? `, {"profile.address.city": {"$in" : ${localizationString} }}`
                    : ""
                }
                ${
                  filters?.classId
                    ? `, {"bootcamps.classId": "${filters?.classId}"}`
                    : ""
                }
                ${
                  filters?.openForProposals !== undefined
                    ? `, {"curriculum.openForProposals": ${filters?.openForProposals}}`
                    : ""
                }
                ${
                  filters?.openForChanges !== undefined
                    ? `, {"curriculum.openForChanges": ${filters?.openForChanges}}`
                    : ""
                }
                ${
                  filters?.openForFreelancer !== undefined
                    ? `, {"curriculum.openForFreelancer": ${filters?.openForFreelancer}}`
                    : ""
                }
                ${
                  filters?.classStatus && filters?.classId
                    ? `, {
                          "bootcamps": {
                            "$elemMatch": {
                              "status": "${filters?.classStatus}", 
                              "classId": "${filters?.classId}"
                            }
                          }
                        }`
                    : ""
                }
                ${
                  filters?.tags
                    ? `, {"bootcamps.tags": "${filters?.tags}"}`
                    : ""
                }
                ${
                  filters?.skill
                    ? `, {
                        "curriculum.skills.key": {
                          $in: ${skillString},
                        },
                      }`
                    : ""
                }
                ${
                  filters?.language
                    ? `, {
                        "curriculum.languages.language": {
                          $in: ${languageString},
                        },
                      }`
                    : ""
                }
              ]
            }
          }${companyId ? userRestrictions(companyId) : ""}
          ${
            filters?.work
              ? `,{"$addFields": {
              "validWork": {
                "$cond": [
                  {
                    "$gte": [
                      {
                          "$size": {
                              "$ifNull": [
                                  {
                                      "$filter": {
                                          "input": "$curriculum.works",
                                          "as": "item",
                                          "cond": {
                                              "$and": [
                                                  {
                                                      "$eq": [
                                                          "$$item.endDate",
                                                          null
                                                      ]
                                                  },
                                                  {
                                                      "$in": [
                                                          "$$item.companyId",
                                                          ${workString}
                                                      ]
                                                  }
                                              ]
                                          }
                                      }
                                  },
                                  []
                              ]
                          }
                      }, 1
                    ]
                  }, true, false
                ]
              }
            }
          }, {
            "$match": {
              "$and": [
                {
                  "validWork": true
                }
              ]
            }
          }`
              : ""
          }
          ${
            filters?.education
              ? `,{"$addFields": {
            "validEducation": {
              "$cond": [
                {
                  "$gte": [
                      {
                          "$size": {
                              "$ifNull": [
                                  {
                                      "$filter": {
                                          "input": "$curriculum.educations",
                                          "as": "item",
                                          "cond": {
                                              "$and": [
                                                  {
                                                      "$eq": [
                                                          "$$item.endDate",
                                                          null
                                                      ]
                                                  },
                                                  {
                                                      "$in": [
                                                          "$$item.companyId",
                                                          ${educationString}
                                                      ]
                                                  }
                                              ]
                                          }
                                      }
                                  },
                                  []
                              ]
                          }
                      }, 1
                  ]
                }, true, false
              ]
            }
          }
        }, {
          "$match": {
            "$and": [{
                "validEducation": true
              }
            ]
          }
        }`
              : ""
          }
        ${onlySize ? onlySizeQuery() : ""}
        ${sortBy ? sortString(sortBy, asc) : ""}
        ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterUsersAdmin = async (
  filters?: {
    name?: string | null;
    roles?: string | null;
    email?: string | null;
    tags?: string | null;
    status?: string | null;
  },
  onlySize = false,
  page?: number,
  limit?: number,
  sortBy?: string,
  asc = true,
): Promise<User[] | null> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[
        {
          $match: {
            $and: [
              ${
                filters?.roles
                  ? `{"account.roles": "${filters?.roles}"}`
                  : '{"account.roles": {"$in": ["ADMIN","ADMIN_CLASS","ADMIN_CLASS_VACANCY","ADMIN_CLASS_VACANCY_BOOTCAMP","ADMIN_CLASS_VACANCY_WORKSHOP","ADMIN_CLASS_VACANCY_VOLUNTEER_MEDIA","ADMIN_CORPORATE","ADMIN_CORPORATE_PLACEMENT_VACANCY"]}}'
              }
              ${
                filters?.name
                  ? `, {"profile.name": {"$regex" : "${filters?.name}", "$options": "im"}}`
                  : ""
              }
              ${
                filters?.status
                  ? `, {"account.status": "${filters?.status}"}`
                  : ""
              }
              ${
                filters?.email
                  ? `, {"profile.email": {"$regex" : "${filters?.email}", "$options": "im"}}`
                  : ""
              }
              ${filters?.tags ? `, {"account.tags": "${filters?.tags}"}` : ""}
            ]
          }
        },
        {
          "$project":{
            "name": "$profile.name",
            "photo": "$profile.photo",
            "roles": "$account.roles",
            "tags": "$account.tags",
            "status": "$account.status",
            "email": "$profile.email",
          }
        }
        ${sortBy ? sortString(sortBy, asc) : ""}
        ${onlySize ? onlySizeQuery() : ""}
        ${page ? paginationString(page) : ""}
        ${limit ? limitedString(limit) : ""}
      ]`,
    });
    return response?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterUserStudent = async (
  filters?: {
    name?: string | null;
    email?: string | null;
    tags?: string | null;
    status?: string | null;
    classId?: string | null;
    legalIdentity?: string;
  },
  onlySize = false,
  page?: number,
  limit?: number,
  sortBy?: string,
  asc = true,
): Promise<any[] | null> => {
  try {
    const response = await api.post("get/user", {
      aggregate: `[
        {
          "$match": {
            "$and": [
              {"account.roles": {"$in": ["STUDENT"]}},
              {"bootcamps.classId": {"$exists": true}}
              ${
                filters?.name
                  ? ` ,{"profile.name": {"$regex" : "${filters?.name}", "$options": "im"}}`
                  : ""
              }
              ${
                filters?.status
                  ? `, {"account.status": "${filters?.status}"}`
                  : ""
              }
              ${
                filters?.email
                  ? `, {"profile.email": {"$regex" : "${filters?.email}", "$options": "im"}}`
                  : ""
              }
              ${
                filters?.legalIdentity
                  ? `,{"profile.legalIdentity": "${filters?.legalIdentity}"}`
                  : ""
              }
              ${filters?.tags ? `, {"bootcamps.tags": "${filters?.tags}"}` : ""}
              ${
                filters?.classId
                  ? `, {"bootcamps.classId": {"$in":["${filters?.classId}"]}}`
                  : ""
              }
            ]
          }
        },
        {
          "$addFields":{ 
            "classesIds": {
              "$map": {
                    "input": "$bootcamps",
                    "in": {
                      "$toObjectId": "$$this.classId",
                }
              }
            }
          }
        },
        {
          "$lookup": {
            "from": "class",
            "localField": "classesIds",
            "foreignField": "_id",
            "as": "class",
          }
        },
        {
          "$project": {
            "name": "$profile.name",
            "photo": "$profile.photo",
            "email":"$profile.email",
            "tags": "$bootcamps.tags",
            "legalIdentity": "$profile.legalIdentity", 
            "status": "$account.status",
            "bootcamps": 1,
            "code": "$class.code"
          }
        }
        ${sortBy ? sortString(sortBy, asc) : ""}
        ${onlySize ? onlySizeQuery() : ""}
        ${page ? paginationString(page) : ""}
        ${limit ? limitedString(limit) : ""}
      ]`,
    });
    return response?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export enum Region {
  NORTE = "NORTE",
  NORDESTE = "NORDESTE",
  CENTRO_OESTE = "CENTRO-OESTE",
  SUDESTE = "SUDESTE",
  SUL = "SUL",
}

const renderFilterRegion = (regions: Region[], isCandidate = false) => {
  const list = {
    NORTE: ["AC", "AM", "RR", "RO", "PA", "AP", "TO"],
    NORDESTE: ["MA", "PI", "CE", "RN", "PB", "PE", "AL", "SE", "BA"],
    "CENTRO-OESTE": ["GO", "MT", "MS", "DF"],
    SUDESTE: ["SP", "MG", "ES", "RJ"],
    SUL: ["RS", "PR", "SC"],
  };

  const arrStates: string[][] = regions?.map((region) => list[region]);
  const states = arrStates
    .reduce((state, sub) => state.concat(sub), [])
    .filter((i) => i);

  let statesString = "[";
  states?.forEach((item, index) => {
    statesString += `${index ? "," : ""}"${item}"`;
    return statesString;
  });
  statesString += "]";

  return `,{"${
    isCandidate ? "user." : ""
  }profile.address.province": {"$in" : ${statesString} }}`;
};

export const filterCandidateUser = async (
  filters: {
    name?: string;
    email?: string;
    legalIdentity?: string;
    genderIdentity?: Array<keyof typeof userGenderIdentity>;
    race?: Array<keyof typeof userRace>;
    disabledPerson?: boolean;
    region?: Region[];
    age?: number;
  },
  limit?: number,
  page?: number,
): Promise<User[] | null> => {
  try {
    let genderIdentityString = "[";
    filters?.genderIdentity?.forEach((item, index) => {
      genderIdentityString += `${index ? "," : ""}"${item}"`;
      return genderIdentityString;
    });
    genderIdentityString += "]";

    let raceString = "[";
    filters?.race?.forEach((item, index) => {
      raceString += `${index ? "," : ""}"${item}"`;
      return raceString;
    });
    raceString += "]";

    const response = await api.post("/get/user", {
      aggregate: `[
        {
          "$addFields" : {
            "profile.age":  { 
              $trunc: [ 
                {
                  "$divide": [
                    {
                      "$subtract": [
                        "$$NOW",
                        {
                          "$dateFromString": {
                            "dateString": "$profile.birthdate",
                            "format": "%d/%m/%Y"
                          }
                        }
                      ]
                    },
                    {
                      "$multiply": [
                        365,
                        24,
                        60,
                        60,
                        1000
                      ]
                    }
                  ]
                }, 
                0
              ]
            }
          }
        },
        {"$match":
        { "$and": [
          {"account.roles": {"$in" : ["CANDIDATE"]}}
          ${filters?.region?.length ? renderFilterRegion(filters?.region) : ""}
          ${
            filters?.name
              ? `,{"profile.name": {"$regex" : "${filters?.name}", "$options": "im"}}`
              : ""
          }
          ${
            filters?.email
              ? `,{"profile.email": {"$regex" : "${filters?.email}", "$options": "im"}}`
              : ""
          }
          ${
            filters?.legalIdentity
              ? `,{"profile.legalIdentity": "${filters?.legalIdentity}"}`
              : ""
          }
          ${filters?.age ? `,{"profile.age": ${filters?.age}}` : ""}
          ${
            filters?.genderIdentity?.length
              ? `,{"profile.genderIdentity": {"$in" : ${genderIdentityString} }}`
              : ""
          }
          ${
            filters?.race?.length
              ? `,{"profile.race": {"$in" : ${raceString} }}`
              : ""
          }
          ${
            "disabledPerson" in filters && filters?.disabledPerson !== undefined
              ? `,{"profile.disabledPerson": ${filters?.disabledPerson}}`
              : ""
          }
        ]}
      },
      {"$sort": {"profile.name": 1}}
      ${limit ? limitedString(limit) : ""}
      ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export enum Revenue {
  TIER_0 = "TIER_0",
  TIER_1 = "TIER_1",
  TIER_2 = "TIER_2",
  TIER_3 = "TIER_3",
  TIER_4 = "TIER_4",
  TIER_5 = "TIER_5",
}

const generateRevenueQuery = (range: Revenue, key: string): string => {
  switch (range) {
    case Revenue.TIER_0:
      return `,{"${key}": {"$lte" : 0}}`;
    case Revenue.TIER_1:
      return `,{"${key}": {"$lte" : 1302}}`;
    case Revenue.TIER_2:
      return `,{"$and" : [{"${key}": {"$gt" : 1302}}, {"${key}": {"$lte" : 2604}}]}`;
    case Revenue.TIER_3:
      return `,{"$and" : [{"${key}": {"$gt" : 2604}}, {"${key}": {"$lte" : 3906}}]}`;
    case Revenue.TIER_4:
      return `,{"$and" : [{"${key}": {"$gt" : 3906}}, {"${key}": {"$lte" : 6510}}]}`;
    case Revenue.TIER_5:
      return `,{"${key}": {"$gte" : 6510}}`;
    default:
      return "";
  }
};

export const filterClassVacancySubscription = async (
  classVacancyId?: string,
  filters?: {
    ids?: string[] | null;
    userId?: string[] | null;
    startDate?: Date | null;
    endDate?: Date | null;
    stageId?: string | null;
    hasStageId?: string | null;
    status?: string | null;
    workshopClass?: string | null;
    workshopFirstOption?: string | null;
    workshopSecondOption?: string | null;
    tags?: string[] | null;
    score?: {
      max?: number;
      min?: number;
      stageId: string;
      isNull?: boolean;
    } | null;
    participant?: string[] | null;
    participed?: boolean | null;
    hasForm?: boolean | null;
    hasTechnical?: boolean | null;
    hasFormDiversity?: boolean | null;
    hasBehavior?: boolean | null;
    childrenOfAge?: boolean | null;
    isLGBTQIA?: boolean | null;
    isReprogramaStudent?: boolean | null;
    similarCourse?: boolean | null;
    educationLevel?: string[] | null;
    ITLevel?: string[] | null;
    hasJSKnowledge?: string[] | null;
    reprogramaStudentOtherClasses?: string[] | null;
    perCapitalRevenue?: Revenue | null;
    montlyRevenue?: Revenue | null;
    isTeacher?: boolean | null;
    hasMedia?: boolean | null;
    hasInternet?: boolean | null;
    hasComputer?: boolean | null;
    hasComments?: boolean | null;
    employabilitySituation?: string[] | null;
    isEmployedInIT?: boolean | null;
    /* --- filters user --- */
    name?: string | null;
    email?: string | null;
    legalIdentity?: string | null;
    genderIdentity?: Array<keyof typeof userGenderIdentity> | null;
    race?: Array<keyof typeof userRace> | null;
    disabledPerson?: boolean | null;
    needAccessibilityAdaptation?: boolean | null;
    region?: Region[] | null;
    age?: number | null;
    userStatus?: string | null;
    photo?: string | null;
    volunteersId?: string[] | null;
  },
  onlySize?: boolean,
  column?: {
    subscriptionStageId?: string;
    mediaStageId?: string;
    workshopStageId?: string;
    talentAcademyStageId?: string;
    testStageId?: string;
  },
  page?: number,
  limit?: number,
  sortBy?: string,
  asc?: boolean,
  pLimit?: number,
  getVolunteers = false,
  getOldSubscriptions = false,
): Promise<ClassVacancySubscriptionDTO[] | null> => {
  if (!classVacancyId && !filters?.workshopClass) return [];

  let tagString: string | null = "[";
  filters?.tags?.forEach((item, index) => {
    tagString += `${index ? "," : ""}"${item}"`;
    return tagString;
  });
  tagString += "]";

  let userIdString = "[";
  filters?.userId?.forEach((item, index) => {
    userIdString += `${index ? "," : ""}"${item}"`;
    return userIdString;
  });
  userIdString += "]";

  let educationLevelString = "[";
  filters?.educationLevel?.forEach((item, index) => {
    educationLevelString += `${index ? "," : ""}"${item}"`;
    return educationLevelString;
  });
  educationLevelString += "]";

  let employabilitySituationString = "[";
  filters?.employabilitySituation?.forEach((item, index) => {
    employabilitySituationString += `${index ? "," : ""}"${item}"`;
    return employabilitySituationString;
  });
  employabilitySituationString += "]";

  let ITLevelString = "[";
  filters?.ITLevel?.forEach((item, index) => {
    ITLevelString += `${index ? "," : ""}"${item}"`;
    return ITLevelString;
  });
  ITLevelString += "]";

  let hasJSKnowledgeString = "[";
  filters?.hasJSKnowledge?.forEach((item, index) => {
    hasJSKnowledgeString += `${index ? "," : ""}"${item}"`;
    return hasJSKnowledgeString;
  });
  hasJSKnowledgeString += "]";

  let reprogramaStudentOtherClassesString = "[";
  filters?.reprogramaStudentOtherClasses?.forEach((item, index) => {
    reprogramaStudentOtherClassesString += `${index ? "," : ""}"${item}"`;
    return reprogramaStudentOtherClassesString;
  });
  reprogramaStudentOtherClassesString += "]";

  let emailsString = "";
  const emailF = filters?.email?.replace(/,/g, " ").replace(/;/g, " ") ?? "";
  if (emailF && emailF?.includes(" ")) {
    const emails = emailF?.split(" ");
    emailsString = "[";
    emails?.forEach((item, index) => {
      emailsString += `${index ? "," : ""}/^${item}$/i`;
      return emailsString;
    });
    emailsString += "]";
  }

  let legalIdentityString = "";
  const legalIdentityF =
    filters?.legalIdentity?.replace(/,/g, " ").replace(/;/g, " ") ?? "";
  if (legalIdentityF && legalIdentityF?.includes(" ")) {
    const emails = legalIdentityF?.split(" ");
    legalIdentityString = "[";
    emails?.forEach((item, index) => {
      legalIdentityString += `${index ? "," : ""}/^${item}$/i`;
      return legalIdentityString;
    });
    legalIdentityString += "]";
  }

  let genderIdentityString = "[";
  filters?.genderIdentity?.forEach((item, index) => {
    genderIdentityString += `${index ? "," : ""}"${item}"`;
    return genderIdentityString;
  });
  genderIdentityString += "]";

  let raceString = "[";
  filters?.race?.forEach((item, index) => {
    raceString += `${index ? "," : ""}"${item}"`;
    return raceString;
  });
  raceString += "]";

  let idsString = "[";
  filters?.ids?.forEach((item, index) => {
    idsString += `${index ? "," : ""}"${item}"`;
    return idsString;
  });
  idsString += "]";

  try {
    let ids: string[] = [];
    let _idsString = "";

    if (
      classVacancyId &&
      filters?.volunteersId &&
      filters?.volunteersId?.length
    ) {
      const volunteers = await getUserAdminClassVacancyVolunterByIds(
        filters?.volunteersId,
      );

      if (classVacancyId && volunteers && volunteers?.length)
        ids = volunteers
          ?.map((item) => item?.classVacancy[classVacancyId])
          ?.reduce((acc, cur) => Object.assign(acc, cur));

      _idsString = "[";
      ids?.forEach((item, index) => {
        _idsString += `${index ? "," : ""}"${item}"`;
        return _idsString;
      });
      _idsString += "]";
    }

    const response = (await api.post("/get/classVacancySubscription", {
      aggregate: `[
        ${
          filters?.score?.stageId
            ? `{"$addFields": {
            "selectedStageToFilterScore":  {
                  "$filter":
                  {
                      "input": "$stages",
                      "as": "stg",
                      "cond": {
                          "$eq": [
                              "$$stg.stageId",
                              "${filters?.score?.stageId}"
                          ]
                      }
                  }
              }
            }},
            {
              "$unwind": {
                "path": "$selectedStageToFilterScore"
              }
            },
            {"$addFields": {
              "selectedStageToFilterScore":  {
                  "$cond": {
                    "if": {
                      "$eq": [{ "$ifNull": ["$selectedStageToFilterScore.grade", 0] }, 0],
                    },
                    "then": false,
                    "else": {
                      "$filter": {
                        "input": "$selectedStageToFilterScore.grade",
                        "as": "gd",
                        "cond": {
                          "$eq": ["$$gd.type", "FINAL"],
                        },
                      },
                    },
                  },
                }
              }}, {
                "$unwind": {
                  "path": "$selectedStageToFilterScore"
                }
              },`
            : ""
        }
          ${
            filters?.stageId
              ? `{"$addFields": {
              "lastStage": {"$last": "$stages"},
              "selectedStage":  {
                  "$filter":
                  {
                      "input": "$stages",
                      "as": "stg",
                      "cond": {
                          "$eq": [
                              "$$stg.stageId",
                              "${filters?.stageId}"
                          ]
                      }
                  }
              }
            }},`
              : ""
          }
          {"$addFields": {
            "id": {"$toString": "$_id"},
          }},
          {
            "$match":{
                "$and": [
                    ${
                      classVacancyId
                        ? `{"classVacancyId": "${classVacancyId}"}`
                        : ""
                    }
                    ${
                      filters?.ids?.length
                        ? `, {"id": {"$in" : ${idsString}}}`
                        : ""
                    }
                    ${ids?.length ? `, {"id": {"$in" : ${_idsString}}}` : ""}
                    ${
                      filters?.workshopClass
                        ? filters?.workshopClass === "isNull"
                          ? `, {"$or": [
                            {"stages.workshopClass": {"$exists": false}},
                            {"stages.workshopClass": "null"},
                            {"stages.workshopClass": ""}
                          ]}`
                          : `, {"stages.workshopClass": "${filters?.workshopClass}"}`
                        : ""
                    }
                    ${
                      filters?.workshopFirstOption
                        ? `, {"$and": [
                          {"stages.options.order": 0},
                          {"stages.options.classId": "${filters?.workshopFirstOption}"}
                        ]}`
                        : ""
                    }
                    ${
                      filters?.workshopSecondOption
                        ? `,{"$and": [
                          {"stages.options.order": 1},
                          {"stages.options.classId": "${filters?.workshopSecondOption}"}
                        ]}`
                        : ""
                    }
                    ${
                      filters?.hasStageId
                        ? `,{"stages.stageId": "${filters?.hasStageId}"}`
                        : ""
                    }
                    ${
                      filters?.tags &&
                      filters?.tags?.length &&
                      !filters?.tags?.includes("Nenhuma")
                        ? `,{"tags": {"$in" : ${tagString}}}`
                        : ""
                    }
                    ${
                      filters?.tags &&
                      filters?.tags?.length &&
                      filters?.tags?.includes("Nenhuma")
                        ? `,{$or: [{"tags": []}, {"tags": {$exists: false}}]}`
                        : ""
                    }
                    ${
                      filters?.userId
                        ? `,{"userId": {"$in" : ${userIdString}}}`
                        : ""
                    }
                    ${
                      filters?.stageId
                        ? `,{"lastStage.stageId": "${filters?.stageId}" }`
                        : ""
                    }
                    ${
                      filters &&
                      "isTeacher" in filters &&
                      filters?.isTeacher !== undefined
                        ? `,{"form.isTeacher": ${filters?.isTeacher} }`
                        : ""
                    }
                    ${
                      filters?.employabilitySituation?.length
                        ? `,{"form.employabilitySituation": {"$in" : ${employabilitySituationString}}}`
                        : ""
                    }
                    ${
                      filters &&
                      "isEmployedInIT" in filters &&
                      filters?.isEmployedInIT !== undefined
                        ? `,{"form.isEmployedInIT": ${filters?.isEmployedInIT} }`
                        : ""
                    }
                    ${
                      filters?.status
                        ? `,{"status": "${filters?.status}" }`
                        : ""
                    }
                    ${
                      filters?.hasComments !== undefined
                        ? `,{"miscellaneous.generalComment.text": {"$exists" : ${filters?.hasComments}}}`
                        : ""
                    }
                    ${
                      filters &&
                      "childrenOfAge" in filters &&
                      filters?.childrenOfAge !== undefined
                        ? `,{"form.childrenOfAge": ${filters?.childrenOfAge} }`
                        : ""
                    }
                    ${
                      filters &&
                      "isLGBTQIA" in filters &&
                      filters?.isLGBTQIA !== undefined
                        ? `,{"form.isLGBTQIA": ${filters?.isLGBTQIA} }`
                        : ""
                    }
                    ${
                      filters &&
                      "isReprogramaStudent" in filters &&
                      filters?.isReprogramaStudent !== undefined
                        ? `,{"form.isReprogramaStudent": ${filters?.isReprogramaStudent} }`
                        : ""
                    }
                    ${
                      filters &&
                      "similarCourse" in filters &&
                      filters?.similarCourse !== undefined
                        ? `,{"form.similarCourse": ${filters?.similarCourse} }`
                        : ""
                    }
                    ${
                      filters?.educationLevel?.length
                        ? `,{"form.educationLevel": {"$in" : ${educationLevelString}}}`
                        : ""
                    }
                    ${
                      filters?.ITLevel?.length
                        ? `,{"form.ITLevel": {"$in" : ${ITLevelString}}}`
                        : ""
                    }
                    ${
                      filters?.hasJSKnowledge?.length
                        ? `,{"form.hasJSKnowledge": {"$in" : ${hasJSKnowledgeString}}}`
                        : ""
                    }
                    ${
                      filters?.reprogramaStudentOtherClasses?.length
                        ? `,{"form.reprogramaStudentOtherClasses": {"$in" : ${reprogramaStudentOtherClassesString}}}`
                        : ""
                    }
                    ${
                      filters?.hasMedia !== undefined
                        ? `,{"form.media": {"$exists" : ${filters?.hasMedia}}}`
                        : ""
                    }
                     ${
                       filters?.hasComputer !== undefined
                         ? `,{"form.hasComputer": ${filters?.hasComputer}}`
                         : ""
                     }
                     ${
                       filters?.hasInternet !== undefined
                         ? `,{"form.hasInternet": ${filters?.hasInternet}}`
                         : ""
                     }
                    ${
                      filters?.startDate
                        ? `,{"startDate": {
                                "$gte":"${moment(filters?.startDate)
                                  .hours(0)
                                  .minutes(0)
                                  .seconds(0)
                                  .milliseconds(0)
                                  .toISOString()}",
                                "$lt":"${moment(filters?.startDate)
                                  .hours(23)
                                  .minutes(59)
                                  .seconds(59)
                                  .milliseconds(59)
                                  .toISOString()}"
                            }}`
                        : ""
                    }
                    ${
                      filters?.endDate
                        ? `,{"endDate": {
                                "$gte":"${moment(filters?.endDate)
                                  .hours(0)
                                  .minutes(0)
                                  .seconds(0)
                                  .milliseconds(0)
                                  .toISOString()}",
                                "$lt":"${moment(filters?.endDate)
                                  .hours(23)
                                  .minutes(59)
                                  .seconds(59)
                                  .milliseconds(59)
                                  .toISOString()}"
                            }}`
                        : ""
                    }
                    ${
                      filters &&
                      "participated" in filters &&
                      filters?.participated !== undefined
                        ? `, {"$and": [
                              {"stages.participant.afternoon": ${filters?.participated}},
                              {"stages.participant.afternoon": ${filters?.participated}}
                            ]}`
                        : ""
                    }
                    ${
                      filters &&
                      "hasForm" in filters &&
                      filters?.hasForm !== undefined &&
                      column?.mediaStageId
                        ? `,{
                              "stages": {
                                $elemMatch: {
                                  stageId: "${column?.mediaStageId}",
                                  "form": {$exists: ${filters?.hasForm}},
                                },
                              },
                            },`
                        : ""
                    }
                    ${
                      filters &&
                      "hasTechnical" in filters &&
                      filters?.hasTechnical !== undefined &&
                      column?.workshopStageId
                        ? `,{
                          $or: [
                            {
                        
                              "stages": {
                                $elemMatch: {
                                  stageId: "${column?.workshopStageId}",
                                  "media": {$exists: ${filters?.hasTechnical}},
                                },
                              },
                            },
                            {
                              "stages.technicalForm": {$exists: ${filters?.hasTechnical}},
                            }
                          ]
                        }`
                        : ""
                    }
                    ${
                      filters &&
                      "hasFormDiversity" in filters &&
                      filters?.hasFormDiversity !== undefined &&
                      column?.workshopStageId
                        ? `,{
                              "stages.diversityForm": {$exists: ${filters?.hasFormDiversity}},
                            },`
                        : ""
                    }
                    ${
                      filters &&
                      "hasBehavior" in filters &&
                      filters?.hasBehavior !== undefined &&
                      column?.workshopStageId
                        ? `,{
                              "stages.behavior": {$exists: ${filters?.hasBehavior}},
                            },`
                        : ""
                    }
                    ${
                      filters?.participant &&
                      filters?.participant?.find((item) => item === "morning")
                        ? `,{"stages.participant.morning": true}`
                        : ""
                    }
                    ${
                      filters?.participant &&
                      filters?.participant?.find((item) => item === "afternoon")
                        ? `,{"stages.participant.afternoon": true}`
                        : ""
                    }
                  ${
                    filters?.participant &&
                    !filters?.participant?.find((item) => item === "morning")
                      ? `,{"$or": [
                          {"stages.participant.morning": false},
                          {"stages.participant.morning": {$exists: false}}
                        ]}`
                      : ""
                  }
                  ${
                    filters?.participant &&
                    !filters?.participant?.find((item) => item === "afternoon")
                      ? `,{"$or": [
                          {"stages.participant.afternoon": false},
                          {"stages.participant.afternoon": {$exists: false}}
                        ]}`
                      : ""
                  }
                    ${
                      filters?.score?.stageId && !filters?.score?.isNull
                        ? `,{"selectedStageToFilterScore.value": { "$gte" : ${
                            filters?.score?.min || 0
                          }}}`
                        : ""
                    }
                    ${
                      filters?.score?.stageId && !filters?.score?.isNull
                        ? `,{"selectedStageToFilterScore.value": { "$lte" : ${
                            filters?.score?.max || 10
                          }}}`
                        : ""
                    }
                    ${
                      filters?.score?.stageId && !!filters?.score?.isNull
                        ? `,{"selectedStageToFilterScore": false}`
                        : ""
                    }
                    ${
                      filters?.perCapitalRevenue
                        ? generateRevenueQuery(
                            filters?.perCapitalRevenue,
                            "form.perCapitalRevenue",
                          )
                        : ""
                    }
                    ${
                      filters?.montlyRevenue
                        ? generateRevenueQuery(
                            filters?.montlyRevenue,
                            "form.montlyRevenue",
                          )
                        : ""
                    }
                    ${
                      filters &&
                      "needAccessibilityAdaptation" in filters &&
                      filters?.needAccessibilityAdaptation !== undefined
                        ? filters?.needAccessibilityAdaptation
                          ? `,{"form.accessibilityAdaptation": {"$exists" : true, "$ne" : ""}}`
                          : `,{"$or": [
                                  {"form.accessibilityAdaptation": ""},
                                  {"form.accessibilityAdaptation": {$exists: false}}
                              ]}`
                        : ""
                    }
                ]
            }
          },
          {
            "$addFields": {
              "objectUserId": {
                "$convert":
                  {
                    "input": "$userId",
                    "to": "objectId",
                    "onError": null,
                    "onNull": null
                  }
              }
            }
          },
          {
            "$lookup" : {
              "from": "user",
              "localField": "objectUserId",
              "foreignField": "_id",
              "as": "user"
            }
          },
          {
            "$project": {
                "user": {
                    "$last": "$user"
                },
                "stages": 1,
                "tags": 1,
                "_id": 1,
                "startDate": 1,
                "endDate": 1,
                "userId": 1,
                "classVacancyId": 1,
                "status": 1,
                "miscellaneous": 1,
                "id": 1,
            }
          },
          {
            "$addFields" : {
              "user.profile.age":  {
                "$trunc": [
                  {
                    "$divide": [
                      {
                        "$subtract": [
                          "$$NOW",
                          {
                            "$dateFromString": {
                              "dateString": "$user.profile.birthdate",
                              "format": "%d/%m/%Y"
                            }
                          }
                        ]
                      },
                      {
                        "$multiply": [
                          365,
                          24,
                          60,
                          60,
                          1000
                        ]
                      }
                    ]
                  },
                  0
                ]
              }
            }
          },
          {"$match":
          { "$and": [
            {"user.account.roles": {"$in" : ["CANDIDATE"]}}
            ${
              filters?.region?.length
                ? renderFilterRegion(filters?.region, true)
                : ""
            }
            ${
              filters?.name
                ? `,{"user.profile.name": {"$regex" : "${filters?.name}", "$options": "im"}}`
                : ""
            }
            ${
              emailsString && emailsString !== ""
                ? `,{"user.profile.email": {"$in" : ${emailsString}}}`
                : filters?.email
                ? `,{"user.profile.email": {"$regex" : "${filters?.email}", "$options": "im"}}`
                : ""
            }
            ${
              legalIdentityString && legalIdentityString !== ""
                ? `,{"user.profile.legalIdentity": {"$in" : ${legalIdentityString}}}`
                : filters?.legalIdentity
                ? `,{"user.profile.legalIdentity": {"$regex" : "${filters?.legalIdentity}", "$options": "im"}}`
                : ""
            }
            ${filters?.age ? `,{"user.profile.age": ${filters?.age}}` : ""}
            ${
              filters?.genderIdentity?.length
                ? `,{"user.profile.genderIdentity": {"$in" : ${genderIdentityString} }}`
                : ""
            }
            ${
              filters?.race?.length
                ? `,{"user.profile.race": {"$in" : ${raceString} }}`
                : ""
            }
            ${
              filters &&
              "disabledPerson" in filters &&
              filters?.disabledPerson !== undefined
                ? `,{"user.profile.disabledPerson": ${filters?.disabledPerson}}`
                : ""
            }
          ]}
        },
        {"$sort": {"user.profile.name": 1}},
          {
            "$match": {
              "$and": [
               {
                "user.profile.name": {
                  "$ne": ""
                }
              },
              {
                "user.profile.name": {
                  "$ne": null
                }
              }
              ]
            }
          },
          {
            "$addFields": {
              "objWorkshop": {
                "$map": {
                  "input": "$stages",
                  "in": {
                    "$toObjectId": "$$this.workshopClass",
                  },
                },
              },
            },
          },
          {
            "$lookup": {
              "from": "class",
              "localField": "objWorkshop",
              "foreignField": "_id",
              "as": "workshop",
            },
          },
          {
            "$addFields": {
              "objBootcamps": {
                "$map": {
                  "input": "$user.bootcamps",
                  "in": {
                    "$toObjectId": "$$this.classId",
                  },
                },
              },
            },
          },
          {
            "$lookup": {
              "from": "class",
              "localField": "objBootcamps",
              "foreignField": "_id",
              "as": "bootcamps",
            },
          },
          ${
            getVolunteers && !!classVacancyId
              ? `{
            "$lookup": {
              "from": "user",
              "localField": "id",
              "foreignField":
                "account.classVacancy.${classVacancyId}",
              "as": "volunteer",
            },
          },`
              : ""
          }
          ${
            getOldSubscriptions
              ? `{
            "$lookup": {
              "from": "classVacancySubscription", 
              "localField": "userId", 
              "foreignField": "userId", 
              "as": "oldClassVacancySubscription"
            }
          }, {
            "$addFields": {
              "objOldClassVacancy": {
                "$map": {
                  "input": "$oldClassVacancySubscription",
                  "in": {
                    "$toObjectId": "$$this.classVacancyId",
                  },
                },
              },
            },
          }, {
            "$lookup": {
              "from": "classVacancy",
              "localField": "objOldClassVacancy",
              "foreignField": "_id",
              "as": "oldClassVacancy",
            },
          },`
              : ""
          }
          {
            "$project": {
                "user": {
                    "name": "$user.profile.name",
                    "legalIdentity": "$user.profile.legalIdentity",
                    "race": "$user.profile.race",
                    "genderIdentity": "$user.profile.genderIdentity",
                    "disabledPerson": "$user.profile.disabledPerson",
                    "email": "$user.profile.email",
                    "state": "$user.profile.address.province",
                    "socialMedias": "$user.profile.socialMedias",
                    "bootcamps": "$user.bootcamps",
                    "account": "$user.account",
                    "status": "$user.account.status",
                    "photo": "$user.profile.photo",
                },
                "stages": 1,
                "_id": 1,
                "startDate": 1,
                "endDate": 1,
                "userId": 1,
                "classVacancyId": 1,
                "status": 1,
                "miscellaneous": 1,
                "tags": 1,
                "classWorkshop": { "$first": "$workshop" },
                "classBootcamps": "$bootcamps",
                "subscriptions": "$oldClassVacancy.title",
                "volunteerName": {"$first": "$volunteer.profile.name"},
                "volunteerEmail": {"$first": "$volunteer.login.identification"}
            }
          }
          ${
            column?.talentAcademyStageId
              ? `,{"$addFields": {
              "talentAcademyScore":  { "$last" : {
                    "$filter":
                    {
                        "input": "$stages",
                        "as": "stg",
                        "cond": {
                            "$eq": [
                                "$$stg.stageId",
                                "${column?.talentAcademyStageId}"
                            ]
                        }
                    }
                }
              }}},
              {"$addFields": {
                "talentAcademyScore":  {"$last": {
                      "$filter":
                      {
                          "input": "$talentAcademyScore.grade",
                          "as": "gd",
                          "cond": {
                              "$eq": [
                                  "$$gd.type",
                                  "FINAL"
                              ]
                          }
                      }
                  }}
                }},
                {"$addFields": {
                  "talentAcademyScore":  "$talentAcademyScore.value"
               }}`
              : ""
          }
          ${
            column?.testStageId
              ? `,{"$addFields": {
            "testScore":  { "$last" : {
                  "$filter":
                  {
                      "input": "$stages",
                      "as": "stg",
                      "cond": {
                          "$eq": [
                              "$$stg.stageId",
                              "${column?.testStageId}"
                          ]
                      }
                  }
              }
            }}},
            {"$addFields": {
              "testScore":  {"$last": {
                    "$filter":
                    {
                        "input": "$testScore.grade",
                        "as": "gd",
                        "cond": {
                            "$eq": [
                                "$$gd.type",
                                "FINAL"
                            ]
                        }
                    }
                }}
              }},
              {"$addFields": {
                "testScore":  "$testScore.value"
             }}`
              : ""
          }
          ${
            column?.workshopStageId
              ? `,{"$addFields": {
              "workshopScore":  { "$last" : {
                    "$filter":
                    {
                        "input": "$stages",
                        "as": "stg",
                        "cond": {
                            "$eq": [
                                "$$stg.stageId",
                                "${column?.workshopStageId}"
                            ]
                        }
                    }
                }
              }}},
                {"$addFields": {
                  "objWorkshopFirstOption": {
                    "$first": {
                      "$map": {
                        "input": {
                          "$filter": {
                            "input": "$workshopScore.options",
                            "as": "option",
                            "cond": {
                              "$eq": ["$$option.order", 0],
                            },
                          },
                        },
                        "in": { "$toObjectId": "$$this.classId" },
                      },
                    },
                  },
                  "objWorkshopSecondOption": {
                    "$first": {
                      "$map": {
                        "input": {
                          "$filter": {
                            "input": "$workshopScore.options",
                            "as": "option",
                            "cond": {
                              "$eq": ["$$option.order", 1],
                            },
                          },
                        },
                        "in": {
                          "$toObjectId": "$$this.classId",
                        },
                      },
                    },
                  },
                },
              },
              {"$lookup": {
                  "from": "class",
                  "localField": "objWorkshopFirstOption",
                  "foreignField": "_id",
                  "as": "workshopFirstOption",
                },
              },
              {"$lookup": {
                  "from": "class",
                  "localField": "objWorkshopSecondOption",
                  "foreignField": "_id",
                  "as": "workshopSecondOption",
                },
              },
              {"$addFields": {
                  "workshopFirstOption": {
                    "$first": "$workshopFirstOption.title",
                  },
                  "workshopSecondOption": {
                    "$first": "$workshopSecondOption.title",
                  },
                },
              },
              {"$addFields": {
                "workshopScore":  {"$last": {
                      "$filter":
                      {
                          "input": "$workshopScore.grade",
                          "as": "gd",
                          "cond": {
                              "$eq": [
                                  "$$gd.type",
                                  "FINAL"
                              ]
                          }
                      }
                }},
                "diversityScore":  {"$last": {
                      "$filter":
                      {
                          "input": "$workshopScore.grade",
                          "as": "gd",
                          "cond": {
                              "$eq": [
                                  "$$gd.type",
                                  "DIVERSITY"
                              ]
                          }
                      }
                  }},
                  "behaviorScore":  {"$last": {
                      "$filter":
                      {
                          "input": "$workshopScore.grade",
                          "as": "gd",
                          "cond": {
                              "$eq": [
                                  "$$gd.type",
                                  "BEHAVIOR"
                              ]
                          }
                      }
                  }},
                  "technicalScore":  {"$last": {
                      "$filter":
                      {
                          "input": "$workshopScore.grade",
                          "as": "gd",
                          "cond": {
                              "$eq": [
                                  "$$gd.type",
                                  "TECHNICAL"
                              ]
                          }
                      }
                  }}
              }},
              {"$addFields": {
                "workshopScore":  "$workshopScore.value",
                "diversityScore":  "$diversityScore.value",
                "behaviorScore":  "$behaviorScore.value",
                "technicalScore":  "$technicalScore.value"
             }}`
              : ""
          }
          ${
            column?.subscriptionStageId
              ? `,{"$addFields": {
              "subscriptionScore":  { "$last" : {
                    "$filter":
                    {
                        "input": "$stages",
                        "as": "stg",
                        "cond": {
                            "$eq": [
                                "$$stg.stageId",
                                "${column?.subscriptionStageId}"
                            ]
                        }
                    }
                }
              }}},
              {"$addFields": {
                "subscriptionScore":  {"$last": {
                      "$filter":
                      {
                          "input": "$subscriptionScore.grade",
                          "as": "gd",
                          "cond": {
                              "$eq": [
                                  "$$gd.type",
                                  "FINAL"
                              ]
                          }
                      }
                  }}
                }},
                {"$addFields": {
                  "subscriptionScore":  "$subscriptionScore.value"
               }}`
              : ""
          }
          ${
            column?.mediaStageId
              ? `,{"$addFields": {
              "mediaScore":  { "$last" : {
                    "$filter":
                    {
                        "input": "$stages",
                        "as": "stg",
                        "cond": {
                            "$eq": [
                                "$$stg.stageId",
                                "${column?.mediaStageId}"
                            ]
                        }
                    }
                }
              }}},
              {"$addFields": {
                "mediaScore":  {"$last": {
                      "$filter":
                      {
                          "input": "$mediaScore.grade",
                          "as": "gd",
                          "cond": {
                              "$eq": [
                                  "$$gd.type",
                                  "FINAL"
                              ]
                          }
                      }
                  }}
                }},
                {"$addFields": {
                  "mediaScore":  "$mediaScore.value"
               }}`
              : ""
          }
          ,{
            "$addFields": {
              "totalScore": {
                "$filter": {
                  "input": {
                    "$reduce": {
                      "input": "$stages.grade",
                      "initialValue": [],
                      "in": {
                        "$concatArrays": [
                          "$$value", "$$this"
                        ]
                      }
                    }
                  },
                  "as": "stg",
                  "cond": {
                    "$eq": [
                      "$$stg.type", "FINAL"
                    ]
                  }
                }
              }
            }
          }, 
          {
            "$addFields": {
              "totalScore": {
                "$avg": "$totalScore.value"
              }
            }
          }
          ${sortBy ? sortString(sortBy, asc) : ""}
          ${onlySize ? onlySizeQuery() : ""}
          ${page ? paginationString(page, pLimit) : ""}
          ${limit ? limitedString(limit) : ""}]`,
    })) as unknown as { data: ClassVacancySubscriptionDTO[] };

    return response?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterClass = async (
  filters?: {
    ids?: string[] | null;
    code?: string | null;
    title?: string | null;
    status?: string | null;
    classStructure?: string[] | null;
  },
  onlySize?: boolean,
  page?: number,
  sortBy?: string,
  asc = true,
): Promise<any> => {
  let classStructureString = "[";
  filters?.classStructure?.forEach((item, index) => {
    classStructureString += `${index ? "," : ""}"${item}"`;
    return classStructureString;
  });
  classStructureString += "]";

  let idsString = "[";
  filters?.ids?.forEach((item, index) => {
    idsString += `${index ? "," : ""}"${item}"`;
    return idsString;
  });
  idsString += "]";

  try {
    const response = await api.post("/get/class", {
      aggregate: `[
        {
          "$addFields": {
            "id": {"$toString": "$_id"},
          }
        },
        {
          "$match": {
            "$and": [
              {"status": {$ne:"DISABLED"}}               
              ${filters?.ids?.length ? `, {"id": {"$in" : ${idsString}}}` : ""}
              ${
                filters?.code
                  ? `, {"code":  {"$regex": "${filters?.code}", "$options": "im" }}`
                  : ""
              }
              ${
                filters?.title
                  ? `, {"title":  {"$regex": "${filters?.title}", "$options": "im" }}`
                  : ""
              }
              ${filters?.status ? `, {"status": "${filters?.status}"}` : ""}
              ${
                filters?.classStructure && filters?.classStructure?.length
                  ? `, {"classStructure": {"$in" : ${classStructureString}}}`
                  : ""
              }
            ]
          }
        }
        ${
          sortBy
            ? sortString(sortBy, asc)
            : `, {"$sort": {"status": 1, "code": 1}}`
        }
        ${onlySize ? onlySizeQuery() : ""}
        ${page ? paginationString(page) : ""}
      ]`,
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const filterCompany = async (
  searchParams: string | null,
  filters: {
    localization?: string[] | null;
    size?: string[] | null;
    financialType?: string[] | null;
  },
  page?: number,
): Promise<Company[] | null> => {
  try {
    let localizationString = "[";
    filters?.localization?.forEach((item, index) => {
      localizationString += `${index ? "," : ""}"${item}"`;
      return localizationString;
    });
    localizationString += "]";

    let sizeString = "[";
    filters?.size?.forEach((item, index) => {
      sizeString += `${index ? "," : ""}"${item}"`;
      return sizeString;
    });
    sizeString += "]";

    let financialTypeString = "[";
    filters?.financialType?.forEach((item, index) => {
      financialTypeString += `${index ? "," : ""}"${item}"`;
      return financialTypeString;
    });
    financialTypeString += "]";

    const response = await api.post("/get/company", {
      aggregate: `[{"$match": {
                "$and": [
                  {"status": "ACTIVE"}
                  ${
                    searchParams
                      ? `,{"profile.name": {"$regex" : "${searchParams}", "$options": "im"}}`
                      : ""
                  }
                  ${
                    filters?.localization
                      ? `,{"profile.location.city": {"$in" : ${localizationString} }}`
                      : ""
                  }
                  ${
                    filters?.size
                      ? `,{"profile.size": {"$in" : ${sizeString} }}`
                      : ""
                  }
                  ${
                    filters?.financialType
                      ? `,{"financialType": {"$in" : ${financialTypeString} }}`
                      : ""
                  }
                ]
              }}${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterVacancy = async (
  searchParams: string | null,
  filters: {
    status?: string[] | null;
    companyId?: string[] | null;
    place?: string[] | null;
    funct?: string[] | null;
    key?: string[] | null;
    managedBy?: string[] | null;
    startDate?: Date | null;
    atDate?: string[];
    endDate?: Date | null;
    date?: {
      startDate?: Date | null;
      endDate?: Date | null;
    };
  },
  page?: number,
  isStudent = false,
): Promise<PlacementVacancy[] | null> => {
  try {
    let statusString = "[";
    filters?.status?.forEach((item, index) => {
      statusString += `${index ? "," : ""}"${item}"`;
      return statusString;
    });
    statusString += "]";

    let companyIdString = "[";
    filters?.companyId?.forEach((item, index) => {
      companyIdString += `${index ? "," : ""}"${item}"`;
      return companyIdString;
    });
    companyIdString += "]";

    let placeString = "[";
    filters?.place?.forEach((item, index) => {
      placeString += `${index ? "," : ""}"${item}"`;
      return placeString;
    });
    placeString += "]";

    let functString = "[";
    filters?.funct?.forEach((item, index) => {
      functString += `${index ? "," : ""}"${item}"`;
      return functString;
    });
    functString += "]";

    let managedByString = "[";
    filters?.managedBy?.forEach((item, index) => {
      managedByString += `${index ? "," : ""}"${item}"`;
      return managedByString;
    });
    managedByString += "]";

    const response = await api.post("/get/placementVacancy", {
      aggregate: `[{"$match": {
                "$and": [
                  ${
                    filters?.status
                      ? `{"status": {"$in" : ${statusString}}}`
                      : isStudent
                      ? '{"status": {"$in" : ["ACTIVE", "PENDING"]}}'
                      : '{"status": {"$in": ["ACTIVE", "FINISHED", "PENDING"]}}'
                  }
                  ${
                    searchParams
                      ? `,{"title": {"$regex" : "${searchParams}", "$options": "im"}}`
                      : ""
                  }
                  ${
                    filters?.companyId
                      ? `,{"companyId": {"$in" : ${companyIdString}}}`
                      : ""
                  }
                  ${
                    filters?.place
                      ? `,{
                        "$or": [
                          {"place": {"$in" : ${placeString}}},
                          {"type": {"$in" : ${placeString}}}
                        ]
                      }`
                      : ""
                  }
                  ${
                    filters?.funct ? `,{"title": {"$in" : ${functString}}}` : ""
                  }
                  ${
                    filters?.key
                      ? `,{"desiredSkills.key": {"$regex": "${filters?.key}", "$options": "im" } }`
                      : ""
                  }
                  ${
                    filters?.managedBy
                      ? `,{"managedBy": {"$in": ${managedByString}}}`
                      : ""
                  }
                  ${
                    filters?.date && filters?.date?.startDate
                      ? `,{"startDate": {
                            "$gte":"${moment(filters?.date.startDate)
                              .hours(0)
                              .minutes(0)
                              .seconds(0)
                              .milliseconds(0)
                              .toISOString()}",
                            "$lt":"${moment().toISOString()}"
                          }}`
                      : ""
                  }
                  ${
                    filters?.startDate
                      ? `,{"startDate": {
                            "$gte":"${moment(filters?.startDate)
                              .hours(0)
                              .minutes(0)
                              .seconds(0)
                              .milliseconds(0)
                              .toISOString()}",
                            "$lt":"${moment(filters?.startDate)
                              .hours(23)
                              .minutes(59)
                              .seconds(59)
                              .milliseconds(59)
                              .toISOString()}"
                          }}`
                      : ""
                  }
                  ${
                    filters?.endDate
                      ? `,{"endDate": {
                            "$gte":"${moment(filters?.endDate)
                              .hours(0)
                              .minutes(0)
                              .seconds(0)
                              .milliseconds(0)
                              .toISOString()}",
                            "$lt":"${moment(filters?.endDate)
                              .hours(23)
                              .minutes(59)
                              .seconds(59)
                              .milliseconds(59)
                              .toISOString()}"
                          }}`
                      : ""
                  }
                ]
              }},
              {"$addFields": {
                  "id": {"$toString": "$_id"},
              }},
              {"$lookup": {
                  "from": "placementVacancySubscription",
                  "localField": "id",
                  "foreignField": "placementVacancyId",
                  "pipeline": [
                    {
                      "$match": { "status": { "$ne": "NONE" } },
                    },
                  ],
                  "as": "subscriptions"
              }},
              {"$addFields": {
                  "subscriptions": {
                    "$size": "$subscriptions"
                  },
              }},
              {"$addFields": {
                "objectCompanyId": {
                  "$convert": {
                    "input": "$companyId",
                    "to":"objectId",
                    "onError": "",
                    "onNull":""
                  }
                }
              }},
              {"$lookup": {
                  "from": "company",
                  "localField": "objectCompanyId",
                  "foreignField": "_id",
                  "as": "companyData"
              }},
              {"$unwind": {
                "path": "$companyData",
              }},
              {"$addFields":{
                  "objectCompanyId": {
                    "$convert":
                    {
                      "input": "$companyId",
                      "to": "objectId",
                      "onError": null,
                      "onNull": null
                    }
                  }
                }},
                {"$lookup": {
                    "from": "company",
                    "localField": "objectCompanyId",
                    "foreignField": "_id",
                    "as": "companyData"
                }},
                {"$unwind": {
                  "path": "$companyData",
                }},
                {"$addFields":{
                  "companyName": "$companyData.profile.name",
                  "photo": "$companyData.profile.logo",
                  "companyWebsite": "$companyData.profile.site",
                  "companyAbout": "$companyData.profile.description",
                }},
                {"$project": {
                  "companyData": 0,
                  "objectCompanyId": 0
                }}${page ? paginationString(page) : ""}]`,
    });

    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const filterPlacementVacancySubscription = async (
  vacancyId: string,
  filters?: {
    userId?: string[] | null;
    name?: string | null;
    skills?: string[] | null;
    stageId?: string | null;
    status?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
  },
  onlySize = false,
  page?: number,
  sortBy = "name",
  asc = true,
): Promise<PlacementVacancySubscription[] | null> => {
  let userIdString = "[";
  filters?.userId?.forEach((item, index) => {
    userIdString += `${index ? "," : ""}"${item}"`;
    return userIdString;
  });
  userIdString += "]";

  let skillsString = "[";
  filters?.skills?.forEach((item, index) => {
    skillsString += `${index ? "," : ""}"${item}"`;
    return skillsString;
  });
  skillsString += "]";

  try {
    const response = await api.post("/get/placementVacancySubscription", {
      aggregate: `[
        ${
          filters?.stageId
            ? `{"$addFields": {
            "lastStage": {"$last": "$stages"}
            }},`
            : ""
        }
        {"$match": {
          "$and": [
            {"placementVacancyId": "${vacancyId}"}
            ${filters?.userId ? `,{"userId": {"$in" : ${userIdString}}}` : ""}
            ${
              filters?.stageId
                ? `,{"lastStage.stageId": "${filters?.stageId}" }`
                : ""
            }
            ${filters?.status ? `,{"status": "${filters?.status}" }` : ""}
            ${
              filters?.startDate
                ? `,{"startDate": {
                      "$gte":"${moment(filters?.startDate)
                        .hours(0)
                        .minutes(0)
                        .seconds(0)
                        .milliseconds(0)
                        .toISOString()}",
                      "$lt":"${moment(filters?.startDate)
                        .hours(23)
                        .minutes(59)
                        .seconds(59)
                        .milliseconds(59)
                        .toISOString()}"
                    }}`
                : ""
            }
            ${
              filters?.endDate
                ? `,{"endDate": {
                      "$gte":"${moment(filters?.endDate)
                        .hours(0)
                        .minutes(0)
                        .seconds(0)
                        .milliseconds(0)
                        .toISOString()}",
                      "$lt":"${moment(filters?.endDate)
                        .hours(23)
                        .minutes(59)
                        .seconds(59)
                        .milliseconds(59)
                        .toISOString()}"
                    }}`
                : ""
            }
          ]}},
          {"$addFields": {
            "objectUserId": {
              "$convert": {
                "input": "$userId",
                "to": "objectId",
                "onError": null,
                "onNull": null
              }
            }
          }},
          {"$lookup" : {
            "from": "user",
            "localField": "objectUserId",
            "foreignField": "_id",
            "as": "userData"
          }},
          {"$unwind": {
            "path": "$userData"
          }},
          {"$addFields": {
            "name": "$userData.profile.name",
            "skills": "$userData.curriculum.skills",
            "roles": "$userData.account.roles",
            "userStatus": "$userData.account.status",
            "photo": "$userData.profile.photo",
            "lastStage": {
              "$last": {
                "$filter": {
                  "input": "$placementVacancyData.stages",
                  "as": "item",
                  "cond": {
                    "$eq": [
                      "$$item.id",
                      { "$last": "$stages.stageId" }
                    ]
                  }
                }
              }
            }
          }},
          {"$match": {
            "$and": [
              {"roles": {"$in" : ["STUDENT"]}},
              {"userStatus": "ACTIVE"}
              ${
                filters?.name
                  ? `, {"name": {"$regex" : "${filters?.name}", "$options": "im"}}`
                  : ""
              }
              ${
                filters?.skills
                  ? `,{"skills.key": {"$in" : ${skillsString}}}`
                  : ""
              }
            ]
          }},
          {"$project": {
            "userData": 0,
            "placementVacancyData": 0,
            "objectUserId": 0,
            "objectPlacementVacancyId": 0,
          }}
          ${sortBy ? sortString(sortBy, asc) : ""}
          ${onlySize ? onlySizeQuery() : ""}
          ${page ? paginationString(page) : ""}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

interface RecapTDO {
  id?: string;
  name?: string;
  legalIdentity?: string;
  email?: string;
  profile?: UserProfile;
  bootcamps?: UserBootcamps[];
  oldBootcamps?: Class[];
  oldClassVacancy?: ClassVacancy[];
  oldClassVacancySubscription?: ClassVacancySubscription[];
  guBootcamps?: Class;
  classVacancy?: ClassVacancy;
  status?: string;
  miscellaneous?: {
    generalComment?: GeneralComment[];
  };
}

export const filterRecapUser = async (
  filters?: {
    name?: string | null;
    legalIdentity?: string | null;
    email?: string | null;
    classCode?: string | null;
    isGiveUp?: boolean | null;
    isWaitingList?: boolean | null;
  },
  onlySize = false,
  page?: number,
  limit?: number,
  sortBy?: string,
  asc = true,
): Promise<RecapTDO[] | null> => {
  let emailsString = "";
  const emailF = filters?.email?.replace(/,/g, " ").replace(/;/g, " ") ?? "";
  if (emailF && emailF?.includes(" ")) {
    const emails = emailF?.split(" ");
    emailsString = "[";
    emails?.forEach((item, index) => {
      emailsString += `${index ? "," : ""}/^${item}$/i`;
      return emailsString;
    });
    emailsString += "]";
  }

  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[
        {
          "$addFields": {
            "objectUserId": {
              "$convert": {
                "input": "$userId", 
                "to": "objectId", 
                "onError": null, 
                "onNull": null
              }
            }
          }
        }, {
          "$lookup": {
            "from": "user", 
            "localField": "objectUserId", 
            "foreignField": "_id", 
            "as": "user"
          }
        }, {
          "$unwind": {
            "path": "$user"
          }
        }, {
          "$match": {
            "$and": [
                {
                  $or: [
                    { "recap.disabled": false },
                    {
                      $and: [
                        { status: "WAITING_LIST" },
                        {
                          $or: [
                            { "recap.disabled": false },
                            {
                              "recap.disabled": {
                                $exists: false,
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      $and: [
                        {
                          status: "APPROVED",
                        },
                        {
                          $or: [
                            {
                              "user.bootcamps.recap.disabled": false,
                            },
                            {
                              "user.bootcamps": {
                                $elemMatch: {
                                  status: "GIVE_UP",
                                  "recap.disabled": false,
                                },
                              },
                            },
                            {
                              "user.bootcamps": {
                                $elemMatch: {
                                  status: "GIVE_UP",
                                  recap: {
                                    $exists: false,
                                  },
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                }
              ${
                filters?.name
                  ? `, {"user.profile.name": {"$regex": "${filters?.name}", "$options": "im" } }`
                  : ""
              } 
              ${
                filters?.legalIdentity
                  ? `, {"user.profile.legalIdentity": "${filters?.legalIdentity}"}`
                  : ""
              }      
              ${
                emailsString && emailsString !== ""
                  ? `, {"user.profile.email": {"$in" : ${emailsString}}}`
                  : filters?.email
                  ? `, {"user.profile.email": {"$regex" : "${filters?.email}", "$options": "im"}}`
                  : ""
              }
            ]
          }
        }, {
          "$addFields": {
            "bGiveUp": {
              "$filter": {
                "input": "$user.bootcamps", 
                "as": "bootcamp", 
                "cond": {
                  "$eq": [
                    "$$bootcamp.status", "GIVE_UP"
                  ]
                }
              }
            }
          }
        }, {
          "$addFields": {
            "objBGiveUp": {
              "$map": {
                "input": "$bGiveUp", 
                "in": {
                  "$toObjectId": "$$this.classId"
                }
              }
            }
          }
        }, {
          "$lookup": {
            "from": "class", 
            "localField": "objBGiveUp", 
            "foreignField": "_id", 
            "as": "bGiveUpClass"
          }
        }, {
          "$addFields": {
            "guBootcamps": {"$last": "$bGiveUpClass"},
            "objBootcamps": {
              "$map": {
                "input": "$user.bootcamps", 
                "in": {
                  "$toObjectId": "$$this.classId"
                }
              }
            }
          }
        }, {
          "$lookup": {
            "from": "class", 
            "localField": "objBootcamps", 
            "foreignField": "_id", 
            "as": "oldBootcamps"
          }
        }, {
          "$addFields": {
            "objectClassVacancyId": {
              "$convert": {
                "input": "$classVacancyId", 
                "to": "objectId", 
                "onError": null, 
                "onNull": null
              }
            }
          }
        }, {
          "$lookup": {
            "from": "classVacancy", 
            "localField": "objectClassVacancyId", 
            "foreignField": "_id", 
            "as": "classVacancy"
          }
        }, {
          "$unwind": {
            "path": "$classVacancy"
          }
        }, {
          "$lookup": {
            "from": "classVacancySubscription", 
            "localField": "userId", 
            "foreignField": "userId", 
            "as": "oldClassVacancySubscription"
          }
        }, {
          "$addFields": {
            "objOldClassVacancy": {
              "$map": {
                "input": "$oldClassVacancySubscription",
                "in": {
                  "$toObjectId": "$$this.classVacancyId",
                },
              },
            },
          },
        }, {
          "$lookup": {
            "from": "classVacancy",
            "localField": "objOldClassVacancy",
            "foreignField": "_id",
            "as": "oldClassVacancy",
          },
        },
        ${
          filters?.isGiveUp
            ? `{
                  "$match": {
                    "status": {"$ne": "WAITING_LIST"},
                  }
                },`
            : ""
        }
        ${
          filters?.isWaitingList
            ? `{
                  "$match": {
                    "status": "WAITING_LIST",
                  }
                },`
            : ""
        }
        ${
          filters?.classCode
            ? `{
                  "$match": {
                    "$or": [
                      {
                        "guBootcamps.code": {"$regex": "${filters?.classCode}", "$options": "im" }
                      },
                      {
                        "classVacancy.title": {"$regex": "${filters?.classCode}", "$options": "im" }
                      }
                    ]
                  }
                },`
            : ""
        }
        {
          "$project": {
            "id": { "$toString": "$user._id" },
            "name": "$user.profile.name", 
            "legalIdentity": "$user.profile.legalIdentity", 
            "email": "$user.profile.email", 
            "profile":"$user.profile",
            "bootcamps": "$user.bootcamps", 
            "oldBootcamps": "$oldBootcamps", 
            "oldClassVacancy": "$oldClassVacancy",
            "oldClassVacancySubscription": "$oldClassVacancySubscription",
            "guBootcamps": "$guBootcamps",
            "classVacancy": "$classVacancy",
            "status":"$status",
            "miscellaneous": "$miscellaneous",
            "form": "$form",
          }
        }
        ${sortBy ? sortString(sortBy, asc) : ""}
        ${onlySize ? onlySizeQuery() : ""}
        ${page ? paginationString(page) : ""}
        ${limit ? limitedString(limit) : ""}
      ]`,
    });

    const result = response?.data?.map(
      (data: {
        oldClassVacancySubscription: {
          classVacancyId: string;
          status: string;
        }[];
        oldClassVacancy: { _id: string; title: string }[];
      }) => {
        const oldSubscriptions = data?.oldClassVacancySubscription?.map(
          (classVacancySubscription: {
            classVacancyId: string;
            status: string;
          }) => {
            const item = data?.oldClassVacancy?.find(
              (classVacancy: { _id: string; title: string }) =>
                classVacancy?._id === classVacancySubscription?.classVacancyId,
            );

            return {
              title: item?.title,
              status: classVacancySubscription?.status,
            };
          },
        );

        return { ...data, oldSubscriptions };
      },
    );

    return result;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

/* SUGGESTIONS */

export const getSuggestionsOfVacancies = async (
  userId: string,
  page?: number,
): Promise<PlacementVacancy[] | null> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
        {
          "$addFields": {
            "userId": {
              "$convert":
              {
                "input": "${userId}",
                "to": "objectId",
                "onError": null,
                "onNull": null
              }
            }
          }
        }, 
        {
          "$lookup": {
            "from": "user",
            "localField": "userId",
            "foreignField": "_id",
            "as": "user"
          }
        },
        {
          "$unwind": {
            "path": "$user"
          }
        },
        {
          "$lookup": {
            "from": "placementVacancy",
            "localField": "a",
            "foreignField": "null",
            "as": "placement"
          }
        },
        {
          "$unwind": {
            "path": "$placement"
          }
        },
        {
          "$match": {
            "placement.status": "ACTIVE"
          }
        },
        {
          "$project": {
            "title": "$placement.title",
            "skills": "$placement.desiredSkills.key",
            "curriculum": "$user.curriculum",
            "placement": "$placement._id"
          }
        },
        {
          "$addFields": {
            "score": {
              "$function": {
                "body": "function a(i,s,e){try{if(!i||!e)return 0;const l=i=>{if(!i)return'';i=i.toLowerCase().trim().replace(/\\s{2,}/g,' ');const s={'-':' ','-':'_',a:'á|à|ã|â|ä|À|Á|Ã|Â|Ä',e:'é|è|ê|ë|É|È|Ê|Ë',i:'í|ì|î|ï|Í|Ì|Î|Ï',o:'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',u:'ú|ù|û|ü|Ú|Ù|Û|Ü',c:'ç|Ç',n:'ñ|Ñ'};for(var e in s);return i.replace(new RegExp(s[e],'g'),e)};e=l(e),s=s.map(i=>l(i)),userSkills=i.skills?i.skills?.map(i=>l(i.key)).join(' ').split(' '):[],userWorkSkills=i.works?i.works.map(i=>l(i.position)+' '+l(i.description)).join(' ').split(' '):[],userEducationSkills=i.educations?i.educations.map(i=>l(i.title)+' '+l(i.description)).join(' ').split(' '):[],userLanguagesSkills=i.languages?i.languages.map(i=>l(i.language)).join(' ').split(' '):[],userCertificateSkills=i.certificates?i.certificates.map(i=>l(i.title)+' '+l(i.description)).join(' ').split(' '):[],userPortfoliosSkills=i.portfolios?i.portfolios.map(i=>l(i.title)+' '+l(i.description)).join(' ').split(' '):[],company=[...e.split(' '),...s.join(' ').split(' ')],user=[...new Set([...userSkills,...userWorkSkills,...userEducationSkills,...userLanguagesSkills,...userCertificateSkills,...userPortfoliosSkills])];let r=0;for(var t of company)user.includes(t)&&r++;return r}catch(er){return 0}}",
                "args": [
                  "$curriculum",
                  "$skills",
                  "$title"
                ],
                "lang": "js"
              }
            }
          }
        },
        {
          "$group": {
            "_id" : "$placement",
            "score": {
              "$first": "$score"
            }
          }
        },
        {
          "$sort": {
            "score":  -1
          }
        },
        {
          "$limit": 15
        },
        {
          "$sample": {
            "size": 3
          }
        }
        ${page ? paginationString(page) : ""}
      ]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getSuggestionsOfUsers = async (
  companyId: string,
  page?: number,
): Promise<User[] | null> => {
  try {
    const response = await api.post("/get/user", {
      aggregate: `[
            {
              "$match": {
                "$and": [
                  {
                    "account.roles": "STUDENT"
                  },
                  {
                    "account.status": "ACTIVE"
                  },
                  {
                    "curriculum.openForProposals": {
                      "$ne": "NO"
                    }
                  }
                ]
              }
            }${companyId ? userRestrictions(companyId) : ""},
            {
              "$addFields": {
                "company": "${companyId}"
              }
            },
            {
              "$lookup": {
                "from": "placementVacancy",
                "localField": "company",
                "foreignField": "companyId",
                "as": "company"
              }
            },
            {
              "$project": {
                "company": {
                  "$last": "$company"
                },
                "curriculum": 1,
                "id": "$_id"
              }
            },
            {
              "$project": {
                "skills": "$company.desiredSkills.key",
                "title": "$company.title",
                "curriculum": 1,
                "id": 1
              }
            },
            {
              "$addFields": {
                "returns": {
                  "$function": {
                    "body": "function a(i,s,e){try{if(!i||!e)return 0;const l=i=>{if(!i)return'';i=i.toLowerCase().trim().replace(/\\s{2,}/g,' ');const s={'-':' ','-':'_',a:'á|à|ã|â|ä|À|Á|Ã|Â|Ä',e:'é|è|ê|ë|É|È|Ê|Ë',i:'í|ì|î|ï|Í|Ì|Î|Ï',o:'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',u:'ú|ù|û|ü|Ú|Ù|Û|Ü',c:'ç|Ç',n:'ñ|Ñ'};for(var e in s);return i.replace(new RegExp(s[e],'g'),e)};e=l(e),s=s.map(i=>l(i)),userSkills=i.skills?i.skills?.map(i=>l(i.key)).join(' ').split(' '):[],userWorkSkills=i.works?i.works.map(i=>l(i.position)+' '+l(i.description)).join(' ').split(' '):[],userEducationSkills=i.educations?i.educations.map(i=>l(i.title)+' '+l(i.description)).join(' ').split(' '):[],userLanguagesSkills=i.languages?i.languages.map(i=>l(i.language)).join(' ').split(' '):[],userCertificateSkills=i.certificates?i.certificates.map(i=>l(i.title)+' '+l(i.description)).join(' ').split(' '):[],userPortfoliosSkills=i.portfolios?i.portfolios.map(i=>l(i.title)+' '+l(i.description)).join(' ').split(' '):[],company=[...e.split(' '),...s.join(' ').split(' ')],user=[...new Set([...userSkills,...userWorkSkills,...userEducationSkills,...userLanguagesSkills,...userCertificateSkills,...userPortfoliosSkills])];let r=0;for(var t of company)user.includes(t)&&r++;return r}catch(er){return 0}}",
                    "args": [
                      "$curriculum",
                      "$skills",
                      "$title"
                    ],
                    "lang": "js"
                  }
                }
              }
            },
            {
              "$group": {
                "_id": "$id",
                "score": {
                  "$sum": "$returns"
                }
              }
            },
            {
              "$sort": {
                "score":  -1
              }
            },
            {
              "$limit": 15
            },
            {
              "$sample": {
                "size": 3
              }
            },
            {
              "$project": {
                "_id": "$_id",
                "score": "$score"
              }
            }
            ${page ? paginationString(page) : ""}
        ]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getSuggestionsOfSimilarVacancies = async (
  refVacancyId: string,
  page?: number,
): Promise<PlacementVacancy[] | null> => {
  try {
    const response = await api.post("/get/placementVacancy", {
      aggregate: `[
          {
              "$match": {
                  "status": "ACTIVE"
              }
          },
          {
              "$addFields": {
                  "reference": {
                      "$convert":
      {
         "input": "${refVacancyId}",
         "to": "objectId",
         "onError": null,
         "onNull": null
      }
                  }
              }
          },
          {
              "$match": {
                  "$expr": {
                      "$ne": [
                          "$_id",
                          "$reference"
                      ]
                  }
              }
          },
          {
              "$lookup": {
                  "from": "placementVacancy",
                  "localField": "reference",
                  "foreignField": "_id",
                  "as": "reference"
              }
          },
          {
              "$unwind": {
                  "path": "$reference"
              }
          },
          {
              "$project": {
                  "reference_title": "$reference.title",
                  "reference_skills": "$reference.desiredSkills.key",
                  "title": 1,
                  "skills": "$desiredSkills.key"
              }
          },
          {
              "$addFields": {
                  "score": {
                      "$function": {
                          "body": "function a(e,r,n,t){try{if(!e||!n)return 0;const o=e=>{if(!e)return'';e=e.toLowerCase().trim().replace(/\\s{2,}/g,' ');const r={'-':' ','-':'_',a:'á|à|ã|â|ä|À|Á|Ã|Â|Ä',e:'é|è|ê|ë|É|È|Ê|Ë',i:'í|ì|î|ï|Í|Ì|Î|Ï',o:'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',u:'ú|ù|û|ü|Ú|Ù|Û|Ü',c:'ç|Ç',n:'ñ|Ñ'};for(var n in r);return e.replace(new RegExp(r[n],'g'),n)};e=o(e),r=r.map(e=>o(e)),n=o(n),t=t.map(e=>o(e));const a=[...new Set([...e.split(' '),...r])],i=[...new Set([...n.split(' '),...t])];let c=0;for(var s of a)i.includes(s)&&c++;return c}catch(er){return 0}}",
                          "args": [
                              "$title",
                              "$skills",
                              "$reference_title",
                              "$reference_skills"
                          ],
                          "lang": "js"
                      }
                  }
              }
          },
          {
              "$sort": {
                  "score": -1
              }
          },
          {
              "$limit": 15
          },
          {
              "$sample": {
                  "size": 3
              }
          },
          {
              "$project": {
                  "_id": "$_id",
                  "score": "$score"
              }
          }
          ${page ? paginationString(page) : ""}
      ]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

/* CLASS */

export const getClassById = async (classId: string): Promise<any> => {
  try {
    const response = await api.get(`/class/${classId}`);
    return response;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const getClassByCode = async (code: string): Promise<any> => {
  try {
    const response = await api.post("/get/class", {
      aggregate: `[{"$match": {"code" : "${code}"}}]`,
    });
    return response?.data;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const getAllClass = async (
  sortBy?: string,
  asc = true,
  limit?: number,
  page?: number,
): Promise<any> => {
  try {
    const response = await api.post("/get/class", {
      aggregate: `[${
        sortBy ? sortString(sortBy, asc) : `{"$sort": {"status": 1, "code": 1}}`
      }${limit ? limitedString(limit) : ""}${
        page ? paginationString(page) : ""
      }]`,
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const getActiveClass = async (): Promise<any> => {
  try {
    const response = await api.post("/get/class", {
      aggregate: '[{"$match": {"status" : "ACTIVE"}}]',
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const createClass = async (data: Class): Promise<any> => {
  try {
    const result = await api
      .post("/class", {
        ...data,
        status: "PENDING",
      })
      .then((res) => {
        logDetails(res.config?.url ?? "", "createClass", "success", data);
        return res;
      })
      .catch((res) =>
        logDetails(res.config?.url ?? "", "createClass", "error"),
      );
    return result?.data;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateClassById = async (
  id: string,
  data: any,
): Promise<boolean> => {
  try {
    const newData = JSON.parse(JSON.stringify({ ...data }));
    delete newData?._id;

    await api
      .patch(`/class/${id}`, newData)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateClassById",
          "success",
          newData,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "updateClassById", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const findUsesClass = async (id: string): Promise<boolean> => {
  try {
    const classVacancy = await api.post("/get/classVacancy", {
      aggregate: `[{"$match": {
            "$or": [
              {"classIds": "${id}"},
              {"stages.classIds": "${id}"}
            ]
          }}]`,
    });

    const subscription = await api.post("/get/classVacancySubscription", {
      aggregate: `[{"$match": {
                "$or": [
                  {"stages.workshopClass": "${id}"},
                  {"stages.options.classId": "${id}"}
                ]
              }}]`,
    });

    const user = await api.post("/get/user", {
      aggregate: `[{"$match": {
            "$or": [
              {"bootcamps.classId": "${id}"},
              {"account.classIds": "${id}"}
            ]
          }}]`,
    });

    const research = await api.post("/get/research", {
      aggregate: `[{"$match": {"classId": "${id}"}}]`,
    });

    return (
      classVacancy?.data?.length ||
      subscription?.data?.length ||
      user?.data?.length ||
      research?.data?.length
    );
  } catch (error) {
    console.warn(error);
    return false;
  }
};
/* CLASS VACANCY */

export const hasClassVacancy = async (): Promise<any> => {
  try {
    const response = await api.get("/hasClassVacancy");
    return response;
  } catch (e) {
    return null;
  }
};

export const getAllActiveClassVacancy = async (): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancy", {
      aggregate: '[{"$match": {"status": "ACTIVE"}}]',
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const getAllClassVacancy = async (
  sortBy = "status",
  asc = true,
): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancy", {
      aggregate: `[${
        sortBy
          ? sortString(sortBy, asc).replace(",", "")
          : `{"$sort": {"status": 1, "startDate": -1}}`
      }]`,
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const filterClassVacancy = async (
  filters?: {
    ids?: string[];
    workshopId?: string;
  },
  onlySize?: boolean,
  page?: number,
  limit?: number,
  sortBy?: string,
  asc = true,
): Promise<any> => {
  let idsString = "[";
  filters?.ids?.forEach((item, index) => {
    idsString += `${index ? "," : ""}"${item}"`;
    return idsString;
  });
  idsString += "]";

  try {
    const response = await api.post("/get/classVacancy", {
      aggregate: `[
        {
          "$addFields": {
            "id": {"$toString": "$_id"},
          }
        },
        {
          "$match": {
              "$and": [
                {"status": {$ne:"DISABLED"}}
                ${
                  filters?.ids?.length ? `, {"id": {"$in" : ${idsString}}}` : ""
                }
                ${
                  filters?.workshopId
                    ? `, {"stages.classIds": "${filters?.workshopId}"}`
                    : ""
                }
              ]
          }
        },
        {
          "$addFields": {
            "objClassIds": {
              "$map": {
                "input": "$classIds",
                "in": {
                  "$toObjectId": "$$this"
                }
              }
            }
          }
        },
        {
          "$lookup": {
            "from": "class",
            "localField": "objClassIds",
            "foreignField": "_id",
            "as": "class"
          }
        }
        ${
          sortBy
            ? sortString(sortBy, asc)
            : `, {"$sort": {"status": 1, "startDate": -1}}`
        }
        ${onlySize ? onlySizeQuery() : ""}
        ${page ? paginationString(page) : ""}
        ${limit ? limitedString(limit) : ""}
      ]`,
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const getClassVacancyById = async (
  classVacancyId: string,
): Promise<any> => {
  try {
    const response = await api.get(`/classVacancy/${classVacancyId}`);
    return response;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const getClassVacancyByClassId = async (
  classId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancy", {
      aggregate: `[{"$match": {"classIds": "${classId}"}}]`,
    });
    return response.data;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const getClassVacancyByStatus = async (status: string): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancy", {
      aggregate: `[{"$match": {"status": "${status}"}}]`,
    });
    return response?.data;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const getClassVacancyStages = async (
  classVacancyId: string,
): Promise<any[]> => {
  try {
    const stages = await api.post("get/classVacancy", {
      aggregate: `[{"$match": {"_id": {"$oid" : "${classVacancyId}"}}}, {"$project" : {"_id" : 0, "stages" : 1}}]`,
    });
    return stages?.data[0].stages.sort(
      (a: { order: number }, b: { order: number }) => a.order - b.order,
    );
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const createClassVacancy = async (
  data: ClassVacancy,
): Promise<boolean> => {
  try {
    await api
      .post("/classVacancy", data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "createClassVacancy",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "createClassVacancy", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateClassVacancyById = async (
  id: string,
  data: any,
): Promise<boolean> => {
  try {
    const newData = JSON.parse(JSON.stringify({ ...data }));
    delete newData?._id;

    await api
      .patch(`/classVacancy/${id}`, newData)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateClassVacancyById",
          "success",
          newData,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "updateClassVacancyById", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

interface IAvailableWorkshop {
  _id: string;
  code: string;
  title: string;
  startDate: string;
  numStudents: number;
  subscriptions?: number;
}

export const getAvailableWorkshop = async (
  classVacancyId: string,
): Promise<IAvailableWorkshop[] | null> => {
  try {
    const response: {
      data: IAvailableWorkshop[];
    } = await api.post("/get/classVacancy", {
      aggregate: `[
        {
          "$addFields": {
            "convertedId": {
              "$convert": {
                "input": "${classVacancyId}", 
                "to": "objectId", 
                "onError": null, 
                "onNull": null
              }
            }
          }
        }, {
          "$match": {
            "$expr": {
              "$eq": [
                "$_id", "$convertedId"
              ]
            }
          }
        }, {
          "$project": {
            "stages": {
              "$filter": {
                "input": "$stages", 
                "as": "stg", 
                "cond": {
                  "$eq": [
                    "$$stg.type", "WORKSHOP"
                  ]
                }
              }
            }
          }
        }, {
          "$unwind": {
            "path": "$stages"
          }
        }, {
          "$unwind": {
            "path": "$stages.classIds"
          }
        }, {
          "$project": {
            "workshopClass": {
              "$convert": {
                "input": "$stages.classIds", 
                "to": "objectId", 
                "onError": null, 
                "onNull": null
              }
            }
          }
        }, {
          "$lookup": {
            "from": "class", 
            "localField": "workshopClass", 
            "foreignField": "_id", 
            "as": "class"
          }
        }, {
          "$unwind": {
            "path": "$class"
          }
        },
        {
          $match: {
            "$and": [
              {"class.status": "ACTIVE"},
              {"$or": [
                {"class.confirmationWorkshop": {"$exists": false}},
                {"class.confirmationWorkshop": false}
              ]}
            ]
          }
        },
        {
          "$project": {
            "_id": "$class._id", 
            "code": "$class.code", 
            "title": "$class.title", 
            "startDate": "$class.startDate", 
            "numStudents": "$class.numStudents", 
            "workshopClass": {
              "$toString": "$class._id"
            }
          }
        }, {
          "$lookup": {
            "from": "classVacancySubscription", 
            "localField": "workshopClass", 
            "foreignField": "stages.workshopClass", 
            "as": "subscriptions"
          }
        }, {
          "$project": {
            "_id": 1, 
            "code": 1, 
            "title": 1, 
            "startDate": 1, 
            "numStudents": {
              "$toInt": "$numStudents"
            }, 
            "subscriptions": {
              "$size": "$subscriptions"
            }
          }
        }
      ]`,
    });

    return response.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

/* CLASS SUBSCRIPTION */

export const getClassVacancySubscriptionById = async (
  classVacancySubscriptionId: string,
): Promise<any> => {
  try {
    const response = await api.get(
      `/classVacancySubscription/${classVacancySubscriptionId}`,
    );
    return response?.data;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const getClassVacancySubscriptionByUserIdAndClassId = async (
  userId: string,
  classId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[
        {
          "$match": {
            "$and": [
              {"userId": "${userId}"},
              {"status": {"$in": ["APPROVED", "WAITING_LIST"]}}
            ]
          }
        },
        {
          "$addFields": {
            "objClassVacancyId": {"$toObjectId": "$classVacancyId"}
          }
        },
        {
          "$lookup": {
            "from": "classVacancy",
            "localField": "objClassVacancyId",
            "foreignField": "_id",
            "as": "classVacancy"
          }
        },
        {
          "$unwind": "$classVacancy"
        },
        {
          "$match": {
            "classVacancy.classIds": "${classId}"
          }
        }
      ]`,
    });

    return response.data;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const getUserEmailByWorkshop = async (classId: string): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[
        {
          "$match":
          {
            "stages.workshopClass": "${classId}",
          }
        },
        {
          "$addFields":
          {
            "objectUserId":
            {
              "$convert":
              {
                "input": "$userId",
                "to": "objectId",
                "onError": null,
                "onNull": null
              }
            }
          }
        },
        {
          "$lookup":
          {
            "from": "user",
            "localField": "objectUserId",
            "foreignField": "_id",
            "as": "user"
          }
        },
        {
          "$unwind":
          {
            "path": "$user"
          }
        },
        {
          "$project": {
            "email": "$user.profile.email"
          }
        }
      ]`,
    });

    return response?.data;
  } catch (error) {
    return null;
  }
};

export const getActiveUserClassVacancySubscription = async (
  userId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[{"$match": {
                "$and": [
                  {"userId": "${userId}"},
                  {"status": "ACTIVE"},
                ]
              }}]`,
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const getAllUserClassVacancySubscription = async (
  userId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[{"$match": {"userId": "${userId}"}}]`,
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const getActiveClassVacancySubscriptionByClassVacancy = async (
  classVacancyId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[{"$match": {
                "$and": [
                  {"classVacancyId": "${classVacancyId}"},
                  {"status": "ACTIVE"},
                ]
              }}]`,
    });
    return response;
  } catch (e) {
    return null;
  }
};

export const getClassVacancySubscriptionWithCommentsByClassVacancy = async (
  classVacancyId: string,
  sortBy?: string,
  asc?: boolean,
): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[
    {
        "$match": {
            "$and": [
              {"classVacancyId":"${classVacancyId}"},
              {"miscellaneous": {"$exists": true}}
            ]
        }
    }, {
        "$addFields": {
            "objectUserId": {
                "$convert": {
                    "input": "$userId", 
                    "to": "objectId", 
                    "onError": null, 
                    "onNull": null
                }
            }
        }
    }, {
        "$lookup": {
            "from": "user", 
            "localField": "objectUserId", 
            "foreignField": "_id", 
            "as": "user"
        }
    }, {
        "$project": {
            "user": {
                "$last": "$user"
            }, 
            "stages": 1, 
            "_id": 1, 
            "startDate": 1, 
            "endDate": 1, 
            "userId": 1, 
            "classVacancyId": 1, 
            "status": 1,
            "miscellaneous": 1, 
            
        }
    }, {
        "$project": {
            "user": {
                "name": "$user.profile.name", 
                "race": "$user.profile.race", 
                "genderIdentity": "$user.profile.genderIdentity", 
                "city": "$user.profile.address.city", 
                "state": "$user.profile.address.province"
            }, 
            "_id": 1, 
            "stages": 1, 
            "miscellaneous": 1, 
            "userId": 1, 
            "classVacancyId": 1, 
            "status": 1,
        }
    }
    ${sortBy ? sortString(sortBy, asc) : ""}
]`,
    });
    return response;
  } catch (e) {
    return null;
  }
};

interface ClassVacancySubscriptionDTOByVacancy {
  user: {
    name: string;
    race: string;
    genderIdentity: string;
    disabledPerson: string;
    email: string;
  };
  stages: any;
  _id: string;
  startDate: Date;
  endDate?: Date;
  userId: string;
  classVacancyId: string;
  status: string;
}

export const getAllClassVacancySubscriptionByClassVacancy = async (
  classVacancyId: string,
  onlySize?: boolean,
  column?: {
    subscriptionStageId?: string;
    mediaStageId?: string;
    workshopStageId?: string;
    talentAcademyStageId?: string;
    testStageId?: string;
  },
  sortBy?: string,
  asc?: boolean,
  page?: number,
  limit?: number,
): Promise<any> => {
  try {
    const response = (await api.post("/get/classVacancySubscription", {
      aggregate: `[
        {
            "$match": {
                "classVacancyId": "${classVacancyId}"
            }
        },
        {
            "$addFields": {
                "objectUserId": {
                    "$convert": {
                        "input": "$userId",
                        "to": "objectId",
                        "onError": null,
                        "onNull": null
                    }
                }
            }
        },
        {
            "$lookup": {
                "from": "user",
                "localField": "objectUserId",
                "foreignField": "_id",
                "as": "user"
            }
        },
        {
            "$project": {
                "user": {
                    "$last": "$user"
                },
                "stages": 1,
                "_id": 1,
                "startDate": 1,
                "endDate": 1,
                "userId": 1,
                "miscellaneous": 1,
                "classVacancyId": 1,
                "status": 1
            }
        },
        {
          "$match": {
            "$and": [
              { 
                "user.profile.name": {
                  "$ne": ""
                }
              },
              { 
                "user.profile.name": {
                  "$ne": null
                }
              }
            ]
          }
        },
        {
            "$project": {
                "user": {
                    "name": "$user.profile.name",
                    "race": "$user.profile.race",
                    "genderIdentity": "$user.profile.genderIdentity",
                    "disabledPerson": "$user.profile.disabledPerson",
                    "email": "$user.profile.email",
                    "state": "$user.profile.address.province",
                    "socialMedias": "$user.profile.socialMedias"
                },
                "email": "$user.login.identification",
                "stages": 1,
                "_id": 1,
                "startDate": 1,
                "endDate": 1,
                "userId": 1,
                "miscellaneous": 1,
                "classVacancyId": 1,
                "status": 1
            }
        }
        ${
          column?.talentAcademyStageId
            ? `,{"$addFields": {
            "talentAcademyScore":  { "$last" : {
                  "$filter":
                  {
                      "input": "$stages",
                      "as": "stg",
                      "cond": {
                          "$eq": [
                              "$$stg.stageId",
                              "${column?.talentAcademyStageId}"
                          ]
                      }
                  }
              }
            }}},
            {"$addFields": {
              "talentAcademyScore":  {"$last": {
                    "$filter":
                    {
                        "input": "$talentAcademyScore.grade",
                        "as": "gd",
                        "cond": {
                            "$eq": [
                                "$$gd.type",
                                "FINAL"
                            ]
                        }
                    }
                }}
              }},
              {"$addFields": {
                "talentAcademyScore":  "$talentAcademyScore.value"
             }}`
            : ""
        }
        ${
          column?.testStageId
            ? `,{"$addFields": {
            "testScore":  { "$last" : {
                  "$filter":
                  {
                      "input": "$stages",
                      "as": "stg",
                      "cond": {
                          "$eq": [
                              "$$stg.stageId",
                              "${column?.testStageId}"
                          ]
                      }
                  }
              }
            }}},
            {"$addFields": {
              "testScore":  {"$last": {
                    "$filter":
                    {
                        "input": "$testScore.grade",
                        "as": "gd",
                        "cond": {
                            "$eq": [
                                "$$gd.type",
                                "FINAL"
                            ]
                        }
                    }
                }}
              }},
              {"$addFields": {
                "testScore":  "$testScore.value"
             }}`
            : ""
        }
        ${
          column?.workshopStageId
            ? `,{"$addFields": {
            "workshopScore":  { "$last" : {
                  "$filter":
                  {
                      "input": "$stages",
                      "as": "stg",
                      "cond": {
                          "$eq": [
                              "$$stg.stageId",
                              "${column?.workshopStageId}"
                          ]
                      }
                  }
              }
            }}},
            {"$addFields": {
              "workshopScore":  {"$last": {
                    "$filter":
                    {
                        "input": "$workshopScore.grade",
                        "as": "gd",
                        "cond": {
                            "$eq": [
                                "$$gd.type",
                                "FINAL"
                            ]
                        }
                    }
                }}
              }},
              {"$addFields": {
                "workshopScore":  "$workshopScore.value"
             }}`
            : ""
        }
        ${
          column?.subscriptionStageId
            ? `,{"$addFields": {
            "subscriptionScore":  { "$last" : {
                  "$filter":
                  {
                      "input": "$stages",
                      "as": "stg",
                      "cond": {
                          "$eq": [
                              "$$stg.stageId",
                              "${column?.subscriptionStageId}"
                          ]
                      }
                  }
              }
            }}},
            {"$addFields": {
              "subscriptionScore":  {"$last": {
                    "$filter":
                    {
                        "input": "$subscriptionScore.grade",
                        "as": "gd",
                        "cond": {
                            "$eq": [
                                "$$gd.type",
                                "FINAL"
                            ]
                        }
                    }
                }}
              }},
              {"$addFields": {
                "subscriptionScore":  "$subscriptionScore.value"
             }}`
            : ""
        }
        ${
          column?.mediaStageId
            ? `,{"$addFields": {
            "mediaScore":  { "$last" : {
                  "$filter":
                  {
                      "input": "$stages",
                      "as": "stg",
                      "cond": {
                          "$eq": [
                              "$$stg.stageId",
                              "${column?.mediaStageId}"
                          ]
                      }
                  }
              }
            }}},
            {"$addFields": {
              "mediaScore":  {"$last": {
                    "$filter":
                    {
                        "input": "$mediaScore.grade",
                        "as": "gd",
                        "cond": {
                            "$eq": [
                                "$$gd.type",
                                "FINAL"
                            ]
                        }
                    }
                }}
              }},
              {"$addFields": {
                "mediaScore":  "$mediaScore.value"
             }}`
            : ""
        }
        ,{
          "$addFields": {
            "totalScore": {
              "$filter": {
                "input": {
                  "$reduce": {
                    "input": "$stages.grade", 
                    "initialValue": [], 
                    "in": {
                      "$concatArrays": [
                        "$$value", "$$this"
                      ]
                    }
                  }
                }, 
                "as": "stg", 
                "cond": {
                  "$eq": [
                    "$$stg.type", "FINAL"
                  ]
                }
              }
            }
          }
        }, {
          "$addFields": {
            "totalScore": {
              "$avg": "$totalScore.value"
            }
          }
        }
        ${sortBy ? sortString(sortBy, asc) : ""}
        ${onlySize ? onlySizeQuery() : ""}
        ${limit ? limitedString(limit) : ""}
        ${page ? paginationString(page) : ""}
      ]`,
    })) as unknown as { data: ClassVacancySubscriptionDTOByVacancy[] };
    return response?.data;
  } catch (e) {
    return null;
  }
};

export const getAllGroupClassVacancySubscriptionStagesByClassVacancy = async (
  classVacancyId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[
        {
            "$match": {
                "classVacancyId":  "${classVacancyId}"
            }
        },
        {
            "$unwind": {
                "path": "$stages"
            }
        },
        {
            "$project": {
                "stages": "$stages"
            }
        },
        {
            "$group": {
                "_id": "$stages.stageId",
                "total": {
                    "$sum": 1
                },
                "approved": {
                    "$sum": {
                        "$cond": [
                            {
                                "$eq": [
                                    "$stages.status",
                                    "APPROVED"
                                ]
                            },
                            1,
                            0
                        ]
                    }
                }
            }
        }
    ]`,
    });
    return response?.data;
  } catch (e) {
    return null;
  }
};

export interface ClassVacancySubscriptionDTO {
  user: {
    name: string;
    race: string;
    genderIdentity: string;
    disabledPerson: string;
    email: string;
    socialMedias: {
      type: keyof typeof userSocialMediaType;
      url: string;
    }[];
    id: string;
    bootcamps: {
      classId: string;
    }[];
  };
  stages: ClassVacancyStages;
  _id: string;
  startDate: Date;
  endDate: Date;
  userId: Date;
  classVacancyId: string;
  status: string;
  ranking?: number;
  subscriptionScore?: number;
  mediaScore?: number;
  workshopScore?: number;
  talentAcademyScore?: number;
  testScore?: number;
  totalScore?: number;
  tags: string[];
}

export const subscriptInClassVacancy = async (
  classVacancyId: string,
  userId: string,
  form: any,
): Promise<boolean> => {
  try {
    const classVacancy = await getClassVacancyById(classVacancyId);
    if (!classVacancy?.data?.stages?.length) return false;
    const zeroStage = classVacancy?.data?.stages[0];

    await api.post("/classVacancySubscription", {
      startDate: date,
      endDate: null,
      classVacancyId,
      userId,
      status: "ACTIVE",
      form,
      stages: [
        {
          startDate: date,
          endDate: null,
          stageId: zeroStage.stage_id,
          status: "IN_PROCESS",
          order: zeroStage?.order ?? 0,
        },
      ],
    });
    return true;
  } catch (error) {
    return false;
  }
};

export const createClassVacancySubscription = async (
  classVacancyId: string,
  userId: string,
  form: any,
  stage: string,
): Promise<boolean> => {
  try {
    const classVacancy = await getClassVacancyById(classVacancyId);

    const stageId = classVacancy?.data?.stages?.find(
      (item: { type: string }) => item?.type === classVacancyType.SUBSCRIPTION,
    )?.stage_id;
    const lastIndex = classVacancy?.data?.stages?.findIndex(
      (item: { type: string }) => item?.type === stage,
    );

    if (
      !classVacancy?.data?.stages?.length ||
      !userId ||
      !form ||
      !stage ||
      !stageId ||
      lastIndex === -1
    )
      return false;

    const stages = [];
    for (let i = 0; i <= lastIndex; i += 1) {
      const newStage = {
        startDate: date,
        endDate: i === lastIndex ? null : date,
        stageId: classVacancy?.data?.stages[i]?.stage_id,
        status: i === lastIndex ? "IN_PROCESS" : "APPROVED",
        order: classVacancy?.data?.stages[i]?.order ?? i ?? 0,
      };
      stages.push(newStage);
    }

    const data = {
      startDate: date,
      endDate: null,
      isRecap: true,
      classVacancyId,
      userId,
      status: "ACTIVE",
      form,
      stages,
    };

    const subscription = await api
      .post("/classVacancySubscription")
      .then((res) => {
        logDetails(
          res.config?.url ?? "",
          "createClassVacancySubscription",
          "success",
          data,
        );
        return res;
      })
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "createClassVacancySubscription",
          "error",
        ),
      );

    if (subscription?.data?._id) {
      const grade = await calcSubscriptionRanking(
        subscription?.data?._id ?? "",
      );

      const idx = subscription?.data?.stages?.findIndex(
        (item: { stageId: string }) => item?.stageId === stageId,
      );

      if (idx > -1 && subscription?.data?.stages?.[idx] && grade) {
        subscription.data.stages[idx].grade = [
          {
            type: "FINAL",
            value: parseFloat(grade?.score?.toFixed(2)) ?? 0,
          },
        ];

        await updateClassVacancySubscriptionById(
          subscription?.data?._id ?? "",
          { stages: subscription?.data?.stages },
        );
      }
    }

    return true;
  } catch (error) {
    return false;
  }
};

interface ClassVacancySubscriptionWithRanking extends ClassVacancySubscription {
  ranking?: number;
}

export const getClassVacancySubscription = async (
  classVacancyId: string,
  userId: string,
): Promise<ClassVacancySubscriptionWithRanking | null> => {
  try {
    const response = (await api.post("get/classVacancySubscription", {
      aggregate: `[{"$match": {"classVacancyId": "${classVacancyId}", "userId": "${userId}"}}]`,
    })) as unknown as { data: ClassVacancySubscriptionWithRanking[] };

    return response?.data[0];
  } catch (error) {
    return null;
  }
};

export const updateClassVacancySubscription = async (
  subscriptionId: string,
  form: any,
): Promise<boolean> => {
  try {
    await api
      .patch(`/classVacancySubscription/${subscriptionId}`, { form })
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateClassVacancySubscription",
          "success",
          { form },
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateClassVacancySubscription",
          "error",
        ),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateClassVacancyInSubscription = async (
  subscriptionId: string,
  classVacancyId: string,
): Promise<boolean> => {
  try {
    const classVacancy = await getClassVacancyById(classVacancyId);
    if (!classVacancy?.data?.stages?.length) return false;
    const zeroStage = classVacancy?.data?.stages[0];

    const data = {
      classVacancyId,
      stages: [
        {
          startDate: date,
          endDate: null,
          stageId: zeroStage.stage_id,
          status: "IN_PROCESS",
          order: zeroStage?.order ?? 0,
        },
      ],
    };
    await api
      .patch(`/classVacancySubscription/${subscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateClassVacancyInSubscription",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateClassVacancyInSubscription",
          "error",
        ),
      );

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateClassVacancySubscriptionById = async (
  id: string,
  data: any,
): Promise<boolean> => {
  try {
    const newData = JSON.parse(JSON.stringify({ ...data }));
    delete newData?._id;

    await api
      .patch(`/classVacancySubscription/${id}`, newData)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateClassVacancySubscriptionById",
          "success",
          newData,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateClassVacancySubscriptionById",
          "error",
        ),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateSubscriptionInClassVacancy = async (
  subscriptionId: string,
  status: string,
  form: any,
  stages: any,
  endDate?: string,
): Promise<boolean> => {
  try {
    const data = {
      endDate,
      status,
      form,
      stages: [stages],
    };
    await api
      .patch(`/classVacancySubscription/${subscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateSubscriptionInClassVacancy",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateSubscriptionInClassVacancy",
          "error",
        ),
      );

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const upClassVacancySubscriptionStage = async (
  classVacancySubscriptionId: string,
  isAdmin = false,
): Promise<boolean> => {
  try {
    const classVacancySubscription = await getClassVacancySubscriptionById(
      classVacancySubscriptionId,
    );

    const classVacancySubscriptionStages = classVacancySubscription?.stages;

    const classVacancy = await getClassVacancyById(
      classVacancySubscription?.classVacancyId,
    );

    const classVacancyStages = classVacancy?.data?.stages;

    const lastSubscriptionStageOrder = classVacancySubscriptionStages?.sort(
      (a: { order: number }, b: { order: number }) => b.order - a.order,
    )[0].order;

    const lastVacancyStageOrder = classVacancyStages?.sort(
      (a: { order: number }, b: { order: number }) => b.order - a.order,
    )[0].order;

    const filteredSubscriptionStages =
      classVacancySubscriptionStages?.map((i: { order: any }) => {
        if (i.order !== lastSubscriptionStageOrder) return i;
        return {
          ...i,
          status: "APPROVED",
          endDate: moment().tz("America/Sao_Paulo").toISOString(),
        };
      }) ?? [];

    const isLastStage = lastVacancyStageOrder === lastSubscriptionStageOrder;

    const lastVacancyStageType = classVacancyStages?.find(
      (stage: { order: any }) => stage?.order === lastSubscriptionStageOrder,
    )?.type;

    if (
      !isAdmin &&
      lastVacancyStageType === "SUBSCRIPTION" &&
      !classVacancySubscription?.form
    )
      return false;

    if (
      !isAdmin &&
      lastVacancyStageType === "UPLOAD_MEDIAS" &&
      !classVacancySubscription?.form?.media &&
      !classVacancySubscription?.stages?.find(
        (item: { order: number }) => item?.order === lastSubscriptionStageOrder,
      )?.form
    )
      return false;

    if (!isAdmin && lastVacancyStageType === "EVALUATE") return false;

    if (isLastStage)
      await api.patch(
        `/classVacancySubscription/${classVacancySubscriptionId}`,
        {
          status: "APPROVED",
          stages: [
            ...filteredSubscriptionStages.sort(
              (a: { order: number }, b: { order: number }) => a.order - b.order,
            ),
          ],
        },
      );
    else {
      const order = lastSubscriptionStageOrder
        ? lastSubscriptionStageOrder + 1
        : 1;

      const stageId = classVacancyStages
        ? classVacancyStages?.find((i: { order: any }) => i.order === order)
            ?.stage_id
        : null;

      await api.patch(
        `/classVacancySubscription/${classVacancySubscriptionId}`,
        {
          status: "ACTIVE",
          stages: [
            ...filteredSubscriptionStages.sort(
              (a: { order: number }, b: { order: number }) => a.order - b.order,
            ),
            {
              stageId,
              startDate: moment().tz("America/Sao_Paulo").toISOString(),
              status: "IN_PROCESS",
              order,
            },
          ],
        },
      );
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const downClassVacancySubscriptionStage = async (
  classVacancySubscriptionId: string,
): Promise<boolean> => {
  try {
    const classVacancySubscription = await getClassVacancySubscriptionById(
      classVacancySubscriptionId,
    );
    const classVacancySubscriptionStages = classVacancySubscription?.stages;

    const lastSubscriptionStageOrder = classVacancySubscriptionStages?.sort(
      (a: { order: number }, b: { order: number }) => b.order - a.order,
    )[0]?.order;

    const filteredSubscriptionStages =
      classVacancySubscriptionStages?.filter(
        (i: { order: any }) => i.order !== lastSubscriptionStageOrder,
      ) ?? [];

    const orderedSubscriptionStages = filteredSubscriptionStages.map(
      (i: { order: number }) => {
        if (
          lastSubscriptionStageOrder &&
          i.order !== lastSubscriptionStageOrder - 1
        )
          return i;

        return {
          ...i,
          endDate: null,
          status: "IN_PROCESS",
        };
      },
    );

    const data = {
      status: "ACTIVE",
      stages: [
        ...orderedSubscriptionStages.sort(
          (a: { order: number }, b: { order: number }) => a.order - b.order,
        ),
      ],
    };
    await api
      .patch(`/classVacancySubscription/${classVacancySubscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "downClassVacancySubscriptionStage",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "downClassVacancySubscriptionStage",
          "error",
        ),
      );

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const rejectUserFromClassVacancySubscriptionStage = async (
  classVacancySubscriptionId: string,
): Promise<boolean> => {
  try {
    const classVacancySubscription = await getClassVacancySubscriptionById(
      classVacancySubscriptionId,
    );
    const classVacancySubscriptionStages = classVacancySubscription?.stages;

    const filteredStages =
      classVacancySubscriptionStages?.map(
        (i: { status: string; endDate: any }, index: number) => {
          if (
            i.status !== "IN_PROCESS" &&
            index < (classVacancySubscriptionStages?.length ?? 1) - 1
          )
            return {
              ...i,
              status: "APPROVED",
              endDate: i.endDate ?? date,
            };

          return {
            ...i,
            status: "DISAPPROVED",
            endDate: date,
          };
        },
      ) ?? [];

    const data = {
      status: "DISAPPROVED",
      endDate: date,
      stages: [
        ...filteredStages.sort(
          (a: { order: number }, b: { order: number }) => a.order - b.order,
        ),
      ],
    };
    await api
      .patch(`/classVacancySubscription/${classVacancySubscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "rejectUserFromClassVacancySubscriptionStage",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "rejectUserFromClassVacancySubscriptionStage",
          "error",
        ),
      );

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const giveUpUserFromClassVacancySubscription = async (
  classVacancySubscriptionId: string,
): Promise<boolean> => {
  try {
    const classVacancySubscription = await getClassVacancySubscriptionById(
      classVacancySubscriptionId,
    );
    const classVacancySubscriptionStages =
      classVacancySubscription?.stages?.sort(
        (a: { order: number }, b: { order: number }) => a.order - b.order,
      );

    const index = (classVacancySubscriptionStages?.length ?? 0) - 1;

    if (index > -1)
      classVacancySubscriptionStages[index] = {
        ...classVacancySubscriptionStages[index],
        status: "GIVE_UP",
        endDate: date,
      };

    const data = {
      status: "FINISHED",
      endDate: date,
      stages: classVacancySubscriptionStages,
    };
    await api
      .patch(`/classVacancySubscription/${classVacancySubscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "giveUpUserFromClassVacancySubscription",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "giveUpUserFromClassVacancySubscription",
          "error",
        ),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const reactiveUserFromClassVacancySubscription = async (
  classVacancySubscriptionId: string,
): Promise<boolean> => {
  try {
    const classVacancySubscription = await getClassVacancySubscriptionById(
      classVacancySubscriptionId,
    );
    const classVacancySubscriptionStages =
      classVacancySubscription?.stages?.sort(
        (a: { order: number }, b: { order: number }) => a.order - b.order,
      );

    const index = (classVacancySubscriptionStages?.length ?? 0) - 1;

    if (index > -1)
      classVacancySubscriptionStages[index] = {
        ...classVacancySubscriptionStages[index],
        status: "IN_PROCESS",
      };

    const data = {
      status: "ACTIVE",
      endDate: date,
      stages: classVacancySubscriptionStages,
    };
    await api
      .patch(`/classVacancySubscription/${classVacancySubscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "reactiveUserFromClassVacancySubscription",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "reactiveUserFromClassVacancySubscription",
          "error",
        ),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const aceptUserFromClassVacancySubscriptionStage = async (
  classVacancySubscriptionId: string,
  waitingList = false,
): Promise<boolean> => {
  try {
    const classVacancySubscription = await getClassVacancySubscriptionById(
      classVacancySubscriptionId,
    );
    const classVacancySubscriptionStages = classVacancySubscription?.stages;

    const filteredStages =
      classVacancySubscriptionStages?.map(
        (i: { status: string; endDate: any }) => ({
          ...i,
          status: "APPROVED",
          endDate: date,
        }),
      ) ?? [];

    const data = {
      status: waitingList ? "WAITING_LIST" : "APPROVED",
      endDate: date,
      stages: [
        ...filteredStages.sort(
          (a: { order: number }, b: { order: number }) => a.order - b.order,
        ),
      ],
    };
    await api
      .patch(`/classVacancySubscription/${classVacancySubscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "aceptUserFromClassVacancySubscriptionStage",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "aceptUserFromClassVacancySubscriptionStage",
          "error",
        ),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const restoreRejectedUserClassVacancySubscription = async (
  classVacancySubscriptionId: string,
): Promise<boolean> => {
  try {
    const classVacancySubscription = await getClassVacancySubscriptionById(
      classVacancySubscriptionId,
    );
    const classVacancySubscriptionStages = classVacancySubscription?.stages;

    const filteredStages =
      classVacancySubscriptionStages
        ?.map((i: { status: string }) => {
          if (i.status === "DISAPPROVED")
            return {
              ...i,
              status: "IN_PROCESS",
              endDate: null,
            };

          return i;
        })
        ?.sort(
          (a: { order: number }, b: { order: number }) => a.order - b.order,
        ) ?? [];

    const data = {
      status: "ACTIVE",
      endDate: null,
      stages: [...filteredStages],
    };
    await api
      .patch(`/classVacancySubscription/${classVacancySubscriptionId}`, data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "restoreRejectedUserClassVacancySubscription",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(
          res.config?.url ?? "",
          "restoreRejectedUserClassVacancySubscription",
          "error",
        ),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const findUsesClassVacancy = async (id: string): Promise<boolean> => {
  try {
    const subscription = await api.post("/get/classVacancySubscription", {
      aggregate: `[
        {"$match": {"classVacancyId": "${id}"}}]`,
    });

    const user = await api.post("/get/user", {
      aggregate: `[{"$match": {"account.classVacancy.${id}": {"$exists": true}}}]`,
    });

    return subscription?.data?.length || user?.data?.length;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

/* STUDENT EMPLOYABILITY SURVEY */

export const createResearchEmployment = async (
  data: Research,
): Promise<boolean> => {
  try {
    await api
      .post("/research", data)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "createResearchEmployment",
          "success",
          data,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "createResearchEmployment", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const updateResearchEmployment = async (
  id: string,
  form: Research,
): Promise<boolean> => {
  try {
    await api
      .patch(`/research/${id}`, form)
      .then((res) =>
        logDetails(
          res.config?.url ?? "",
          "updateResearchEmployment",
          "success",
          form,
        ),
      )
      .catch((res) =>
        logDetails(res.config?.url ?? "", "updateResearchEmployment", "error"),
      );
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const getEmploymentById = async (id: string): Promise<any> => {
  try {
    const response = await api.get(`/research/${id}`);
    return response;
  } catch (error) {
    console.warn(error);
    return [];
  }
};

export const getResearchActive = async (classIds: string[]): Promise<any> => {
  let idsString = "[";
  classIds?.forEach((item, index) => {
    idsString += `${index ? "," : ""}"${item}"`;
    return idsString;
  });
  idsString += "]";

  try {
    const response = await api.post("/get/class", {
      aggregate: `
      [
        {
          "$addFields": {
            "id": {"$toString": "$_id"},
          },
        },
        {
          "$match":
            {
              "$and": 
              [
                {"id": {"$in" : ${idsString} }},
                {"forms.enable": true},
              ]
            }
        }
      ]
      `,
    });

    return response?.data;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserIdResearchBySupervisionId = async (
  supervisionId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/research", {
      aggregate: `[{"$match": {"form.supervisionId": "${supervisionId}"}}]`,
    });
    return (
      response?.data?.map((item: { userId: string }) => item?.userId) ?? null
    );
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getUserIdResearchBySupervisionIdAndClassId = async (
  supervisionId: string,
  classId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/research", {
      aggregate: `[{"$match":
            {"$and": [
              {"form.supervisionId": "${supervisionId}"},
              {"classId": "${classId}"}
            ]}
          }]`,
    });
    return (
      response?.data?.map((item: { userId: string }) => item?.userId) ?? null
    );
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getSupervision = async (classId: string): Promise<any> => {
  try {
    const response = await api.post("/get/research", {
      aggregate: `[{"$match":
            {"$and": [
              {"classId": "${classId}"},
              {"form.supervisionId": {"$exists": true}}
            ]}
          },
          {
            "$project": {
              "form": 1,
            }
          },
          {"$addFields": {
            "objectUserId": {
              "$convert": {
                "input": "$form.supervisionId",
                "to":"objectId",
                "onError": "",
                "onNull":""
              }
            }
          }},
          {"$lookup": {
              "from": "user",
              "localField": "objectUserId",
              "foreignField": "_id",
              "as": "userData"
          }},
          {"$unwind": {
            "path": "$userData",
          }},
          {"$addFields":{
            "email": "$userData.login.identification",
            "userId": { "$toString": "$_id" },
          }},
          {"$project": {
            "userData": 0,
            "objectUserId": 0
          }},
          {"$match": {
            "$or": [
              {"researchData": {"$exists": false}},
              {"researchData": {"$size": 0}},
              {"researchData.hasFinished": false}
            ]
          }},
          {"$group": {
            "_id": null,
            "emails": { "$addToSet": "$email" },
          }}
        ]`,
    });
    return response?.data?.[0]?.emails ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getResearchByUserIdAndClassIdAndType = async (
  userId: string,
  classId: string,
  type: keyof typeof researchType,
): Promise<any> => {
  try {
    const response = await api.post("/get/research", {
      aggregate: `[{"$match":
            {"$and": [
              {"type": "${type}" },
              {"userId": "${userId}"},
              {"classId": "${classId}"}
            ]}
          }]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const getResearchByCompanyIdAndUserId = async (
  userId: string,
  companyId: string,
): Promise<any> => {
  try {
    const response = await api.post("/get/research", {
      aggregate: `[{"$match":
            {"$and": [
              {"type": "COMPANY" },
              {"companyId": "${companyId}"},
              {"userId": "${userId}"}
            ]}
          }]`,
    });
    return response?.data ?? null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

/* RANKING */

interface RankingResponse {
  _id: string;
  score: number;
}

export const calcSubscriptionRanking = async (
  subscriptionId: string,
): Promise<RankingResponse | null> => {
  try {
    const response = await api.post("/get/classVacancySubscription", {
      aggregate: `[
            {
                "$project": {
                    "form": 1,
                    "userId": {
                        "$toObjectId": "$userId"
                    },
                    "classVacancyId": 1,
                    "objSubscriptionId": {
                        "$toObjectId": "${subscriptionId}"
                    },
                    "startDate": 1
                }
            },
            {
              "$match": {
                  "$expr": {
                      "$eq": [
                          "$_id",
                          "$objSubscriptionId"
                      ]
                  }
              }
            },
            {
                "$lookup": {
                    "from": "classVacancyRanking",
                    "localField": "classVacancyId",
                    "foreignField": "classVacancyIds",
                    "as": "ranking"
                }
            },
            {
                "$unwind": {
                    "path": "$ranking"
                }
            },
            {
                "$lookup": {
                    "from": "user",
                    "localField": "userId",
                    "foreignField": "_id",
                    "as": "user"
                }
            },
            {
                "$project": {
                    "user": {
                        "$first": "$user"
                    },
                    "userId": 1,
                    "form": 1,
                    "ranking": "$ranking.ranking",
                    "classVacancy": 1
                }
            },
            {
                "$addFields": {
                    "user": {
                        "typeCity": {
                            "$cond": [
                                {
                                    "$in": [
                                        "$user.profile.address.city",
                                        [
                                            "Rio Branco",
                                            "Macapá",
                                            "Manaus",
                                            "Belém",
                                            "Porto Velho",
                                            "Boa Vista",
                                            "Palmas",
                                            "Maceió",
                                            "Salvador",
                                            "Fortaleza",
                                            "São Luís",
                                            "João Pessoa",
                                            "Recife",
                                            "Teresina",
                                            "Natal",
                                            "Aracaju",
                                            "Brasília",
                                            "Goiânia",
                                            "Cuiabá",
                                            "Campo Grande",
                                            "Vitória",
                                            "Belo Horizonte",
                                            "Rio de Janeiro",
                                            "São Paulo",
                                            "Curitiba",
                                            "Florianópolis",
                                            "Porto Alegre"
                                        ]
                                    ]
                                },
                                "CAPITAL",
                                "INTERIOR"
                            ]
                        },
                        "region": {
                            "$cond": [
                                {
                                    "$in": [
                                        "$user.profile.address.province",
                                        [
                                            "SP",
                                            "MG",
                                            "ES",
                                            "RJ"
                                        ]
                                    ]
                                },
                                "SUDESTE",
                                {
                                    "$cond": [
                                        {
                                            "$in": [
                                                "$user.profile.address.province",
                                                [
                                                    "RS",
                                                    "PR",
                                                    "SC"
                                                ]
                                            ]
                                        },
                                        "SUL",
                                        {
                                            "$cond": [
                                                {
                                                    "$in": [
                                                        "$user.profile.address.province",
                                                        [
                                                            "GO",
                                                            "MT",
                                                            "MS",
                                                            "DF"
                                                        ]
                                                    ]
                                                },
                                                "CENTRO-OESTE",
                                                {
                                                    "$cond": [
                                                        {
                                                            "$in": [
                                                                "$user.profile.address.province",
                                                                [
                                                                    "AC",
                                                                    "AM",
                                                                    "RR",
                                                                    "RO",
                                                                    "PA",
                                                                    "AP",
                                                                    "TO"
                                                                ]
                                                            ]
                                                        },
                                                        "NORTE",
                                                        {
                                                            "$cond": [
                                                                {
                                                                    "$in": [
                                                                        "$user.profile.address.province",
                                                                        [
                                                                            "MA",
                                                                            "PI",
                                                                            "CE",
                                                                            "RN",
                                                                            "PB",
                                                                            "PE",
                                                                            "AL",
                                                                            "SE",
                                                                            "BA"
                                                                        ]
                                                                    ]
                                                                },
                                                                "NORDESTE",
                                                                "OUTROS"
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        "age": {
                            "$divide": [
                                {
                                    "$subtract": [
                                        "$$NOW",
                                        {
                                            "$dateFromString": {
                                                "dateString": "$user.profile.birthdate",
                                                "format": "%d/%m/%Y"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "$multiply": [
                                        365,
                                        24,
                                        60,
                                        60,
                                        1000
                                    ]
                                }
                            ]
                        },
                        "name": "$user.profile.name",
                        "race": "$user.profile.race",
                        "address": "$user.profile.address",
                        "familyTotalRevenue": "$user.profile.familyTotalRevenue",
                        "montlyRevenue": "$user.profile.montlyRevenue",
                        "genderIdentity": "$user.profile.genderIdentity",
                        "disabledPerson": "$user.profile.disabledPerson"
                    },
                    "form.socialClass": {
                      "$function": {
                        "body": "function getSocialClass(e){let{privateVehicles:a,monthlyEmployees:E,washingMachines:c,bathrooms:s,dvdDevices:O,refrigerators:N,freezers:R,microcomputers:r,dishwashers:T,microwaves:b,professionalMotorcycles:k,clothesDryers:C,originOfWater:L,TypeOfStreet:H,levelEducationBoss:M}=e;if(!a||!E||!c||!s||!O||!N||!R||!r||!T||!b||!k||!C||!L||!H||!M)return null;let t=0;switch(a){case'NONE':t+=0;break;case'ONE':t+=3;break;case'TWO':t+=5;break;case'THREE':t+=8;break;case'FOUR_MORE':t+=11}switch(E){case'NONE':t+=0;break;case'ONE':t+=3;break;case'TWO':t+=7;break;case'THREE':t+=10;break;case'FOUR_MORE':t+=13}switch(c){case'NONE':t+=0;break;case'ONE':t+=2;break;case'TWO':t+=4;break;case'THREE':case'FOUR_MORE':t+=6}switch(s){case'NONE':t+=0;break;case'ONE':t+=3;break;case'TWO':t+=7;break;case'THREE':t+=10;break;case'FOUR_MORE':t+=14}switch(O){case'NONE':t+=0;break;case'ONE':t+=1;break;case'TWO':t+=3;break;case'THREE':t+=4;break;case'FOUR_MORE':t+=6}switch(N){case'NONE':t+=0;break;case'ONE':t+=2;break;case'TWO':t+=3;break;case'THREE':case'FOUR_MORE':t+=5}switch(R){case'NONE':t+=0;break;case'ONE':t+=2;break;case'TWO':t+=4;break;case'THREE':case'FOUR_MORE':t+=6}switch(r){case'NONE':t+=0;break;case'ONE':t+=3;break;case'TWO':t+=6;break;case'THREE':t+=8;break;case'FOUR_MORE':t+=11}switch(T){case'NONE':t+=0;break;case'ONE':t+=3;break;case'TWO':case'THREE':case'FOUR_MORE':t+=6}switch(b){case'NONE':t+=0;break;case'ONE':t+=2;break;case'TWO':case'THREE':case'FOUR_MORE':t+=4}switch(k){case'NONE':t+=0;break;case'ONE':t+=1;break;case'TWO':case'THREE':case'FOUR_MORE':t+=3}switch(C){case'NONE':t+=0;break;case'ONE':case'TWO':case'THREE':case'FOUR_MORE':t+=2}switch(L){case'GENERAL':t+=4;break;case'SOURCE':case'OTHER':t+=0}switch(H){case'ASPHALT':t+=2;break;case'GRAVEL':t+=0}switch(M){case'INCOMPLETE_ELEMENTARY_SCHOOL':t+=0;break;case'COMPLETE_ELEMENTARY_SCHOOL':case'INCOMPLETE_HIGH_SCHOOL':t+=1;break;case'COMPLETE_HIGH_SCHOOL':t+=2;break;case'INCOMPLETE_TECHNICAL_COURSE':case'TECHNICAL_COURSE_IN_PROGRESS':case'COMPLETE_TECHNICAL_COURSE':case'INCOMPLETE_COLLEGE_EDUCATION':case'COLLEGE_EDUCATION_IN_PROGRESS':t+=4;break;case'COMPLETE_COLLEGE_EDUCATION':case'ESPECIALIZATION':case'MASTER':case'DOCTORATE':t+=7}return t}",
                        "args": ["$form"],
                        "lang": "js"
                      }
                    }
                }
            },
            {
                "$project": {
                    "_id": 1,
                    "score": {
                        "$function": {
                            "body": "function minVersion(e,i,c){if(!e.length)return 0;let s=0,t=0;e.forEach(e=>{let r,a=!1;e.field.split('.').forEach(e=>{if(r)e in r||(a=!0),r=a?null:r[e];else switch(e){case'user':r=c;break;case'form':r=i;break;default:a=!0}});let l=!1,n=(e,i=1,c=!1)=>{s+=e*i,t+=i,l=!c},o=e=>{if('string'==typeof e){let i=parseFloat(r.replace(',','.'));if('number'==typeof i&&!isNaN(i))return i;let c=new Date(e);if('Invalid Date'!==c&&!isNaN(c))return c.getTime()}return e};e.switch.forEach(i=>{if(!l){let c;switch(i.operation){case'gte':(c=o(r))>=(dCase=o(i.case))&&n(i.score,e?.weight,e.inclusiveMode);break;case'lte':(c=o(r))<=(dCase=o(i.case))&&n(i.score,e.weight,e.inclusiveMode);break;case'gt':(c=o(r))>(dCase=o(i.case))&&n(i.score,e.weight,e.inclusiveMode);break;case'lt':(c=o(r))<(dCase=o(i.case))&&n(i.score,e.weight,e.inclusiveMode);break;case'ne':(c=o(r))!==(dCase=o(i.case))&&n(i.score,e.weight,e.inclusiveMode);break;case'in':i.case.includes(r)&&n(i.score,e.weight,e.inclusiveMode);break;case'nin':i.case.includes(r)||n(i.score,e.weight,e.inclusiveMode);break;default:r===i.case&&n(i.score,e.weight,e.inclusiveMode)}}})});let r=s/(t||1);return r<0?0:r}",
                            "args": [
                                "$ranking",
                                "$form",
                                "$user"
                            ],
                            "lang": "js"
                        }
                    }
                }
            }
        ]`,
    });

    return response?.data[0];
  } catch (e) {
    return null;
  }
};

export const createAnalytics = async (data: any): Promise<boolean> => {
  try {
    await api.post("/analytics", data);

    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};
